import PaymentQRDisplay from '../components/PaymentQRDisplay';
import React, { useContext, useEffect, useRef, useState } from 'react'
// import { useTranslation } from 'react-i18next';
// import Page from "../components/Page";
// import { IconPlus, IconNotes, IconArmchair, IconScreenShare, IconSearch, IconDeviceFloppy, IconChefHat, IconCash, IconMinus, IconNote, IconTrash, IconFilter, IconPhoto, IconFilterFilled, IconClipboardList, IconX, IconClearAll, IconPencil, IconCheck, IconCarrot, IconRotate, IconQrcode, IconArmchair2, IconUser, IconCategory, IconGridDots, IconLayoutGrid, IconListDetails, IconListTree, IconMenu4, IconLayoutGridFilled, IconMenu2, IconLayoutList, IconLayout2, IconLayout2Filled, IconAlertTriangleFilled } from "@tabler/icons-react";
// import { VITE_BACKEND_SOCKET_IO, iconStroke } from "../config/config";
// import { cancelAllQROrders, cancelQROrder, createOrder, createOrderAndInvoice, getDrafts, getQROrders, getQROrdersCount, initPOS, setDrafts } from "../controllers/pos.controller";
import { getCustomerLoyalty, useLoyaltySettings } from '../controllers/loyalty.controller';
// import { CURRENCIES } from '../config/currencies.config';
// import { PAYMENT_ICONS } from "../config/payment_icons";
// import { toast } from "react-hot-toast";
// import { searchCustomer } from '../controllers/customers.controller';
// import { Link, useNavigate } from 'react-router-dom';
// import { setDetailsForReceiptPrint } from '../helpers/ReceiptHelper';
// import { useSocket } from "../contexts/SocketContext";
// ;// ✅ Keep this for context
// import { getImageURL } from '../helpers/ImageHelper';
// import { getUserDetailsInLocalStorage } from '../helpers/UserDetails';
// import AsyncCreatableSelect from 'react-select/async-creatable';
// import DialogAddCustomer from '../components/DialogAddCustomer';
// import POSMenuItemDetailedView from '../components/POSMenuItemDetailedView';
// import POSMenuItemCompactView from '../components/POSMenuItemCompactView';
// import { clsx } from "clsx";
// import { useTheme } from '../contexts/ThemeContext';
import { groupItemsByPrinter, printKOT } from '../helpers/PrinterHelper';

// // ✅ CORRECT - Single import from socket utils

// export default function POSPage() {
//   const { t } = useTranslation();
//   const user = getUserDetailsInLocalStorage();
//   const { socket, isConnected, safeEmit, initSocket, getSocket, waitForConnection, disconnectSocket } = useSocket();
//   const navigate = useNavigate();
//   const { theme } = useTheme();
//   const diningOptionRef = useRef();
//   const tableRef = useRef();

//   // dialog: notes ref
//   const dialogNotesIndexRef = useRef();
//   const dialogNotesTextRef = useRef();
//   // dialog: notes ref

//   // dialog: category filter
//   const categoryFilterDropdownRef = useRef(null);
//   // dialog: category filter

//   // dialog: category filter
//   const draftTitleRef = useRef(null);
//   // dialog: category filter

//   // dialog: search customer
//   const searchCustomerRef = useRef(null);
//   // dialog: search customer

//   const tapSound = new Audio("/tap.mp3");

//   const [state, setState] = useState({
//     view:"detailed",
//     categories: [],
//     menuItems: [],
//     paymentTypes: [],
//     printSettings: null,
//     storeSettings: null,
//     storeTables: [],
//     serviceCharge:null,
//     currency: "",
//     isLoading: true,

//     cartItems: [],
//     customerType: "WALKIN",
//     customer: null,
//     addCustomerDefaultValue: null,

//     searchQuery: "",
//     selectedCategory: "all",

//     selectedItemId: null,

//     drafts: [],

//     itemsTotal: 0,
//     taxTotal: 0,
//     serviceChargeTotal:0,
//     payableTotal: 0,

//     orderId: null,
//     tokenNo: null,

//     qrOrdersCount: 0,
//     qrOrders: [],
//     selectedQrOrderItem: null,

//     selectedPaymentType: null,
//   });

// //   useEffect(()=>{
// //     _initPOS();
// //     _initSocket();
// //   },[]);

// //   const { categories, menuItems, paymentTypes, printSettings, storeSettings, storeTables, currency, cartItems, searchQuery, selectedCategory, selectedItemId, drafts, customer, customerType, isLoading } = state;

// // // GLOBAL SAFE LOADER — prevents ALL react-select crashes
// // const safeLoadOptions = (fn) => {
// //   return (input) => {
// //     return new Promise((resolve) => {
// //       setTimeout(async () => {
// //         try {
// //           const result = await fn(input);
// //           resolve(Array.isArray(result) ? result : []);
// //         } catch (err) {
// //           console.error("safeLoadOptions error:", err);
// //           resolve([]);
// //         }
// //       }, 0);
// //     });
// //   };
// // };

// //  // Import the safe functions

// // const sendNewOrderEvent = (tokenNo, orderId) => {
// //   // Use the safeEmit function from your socket utils
// //   const success = safeEmit('new_order_backend', { 
// //     tokenNo, 
// //     orderId, 
// //     tenantId: user.tenant_id 
// //   });

// //   if (!success) {
// //     console.warn('⚠️ Order event not sent via socket (will still be created in database)');
// //   }
// // }

// // const playTapSound = () => {
// //   tapSound.play();
// // }

//   useEffect(()=>{
//     _initPOS();
//     _initSocket();
//   },[]);

//   const { categories, menuItems, paymentTypes, printSettings, storeSettings, storeTables, currency, cartItems, searchQuery, selectedCategory, selectedItemId, drafts, customer, customerType, isLoading } = state;



//   const sendNewOrderEvent = (tokenNo, orderId) => {
//     if (isSocketConnected) {
//       socket.emit('new_order_backend', {tokenNo, orderId}, user.tenant_id);
//     } else {
//       // Handle disconnected state (optional)
//       initSocket();
//       socket.emit('new_order_backend', {tokenNo, orderId}, user.tenant_id);
//     }
//   }

//   const playTapSound = () => {
//     tapSound.play();
//   }


// async function _initPOS() {
//   try {
//     console.log("Starting POS initialization...");

//     const fullRes = await initPOS();
//     console.log("initPOS raw response:", fullRes);

//     // More defensive data extraction
//     const data = fullRes?.data ?? fullRes ?? {};
//     console.log("Processed POS data:", data);

//     // Validate critical data structures
//     if (!data || typeof data !== 'object') {
//       throw new Error('Invalid POS data structure received');
//     }

//     const {
//       categories = [],
//       menuItems = [],
//       paymentTypes = [],
//       printSettings = null,
//       storeSettings = null,
//       storeTables = [],
//       serviceCharge = null,
//     } = data;

//     // Validate storeSettings exists before accessing currency
//     if (!storeSettings || typeof storeSettings !== 'object') {
//       console.warn('storeSettings is missing or invalid');
//     }

//     const currencySymbol = storeSettings?.currency
//       ? CURRENCIES.find(c => c.cc === storeSettings.currency)?.symbol || ""
//       : "";

//     let totalQROrders = 0;
//     try {
//       const qrRes = await getQROrdersCount();
//       totalQROrders = qrRes?.data?.totalQROrders ?? 0;
//     } catch (qrError) {
//       console.warn('Failed to fetch QR orders count:', qrError);
//     }

//     setState(prev => ({
//       ...prev,
//       categories: Array.isArray(categories) ? categories : [],
//       menuItems: Array.isArray(menuItems) ? menuItems : [],
//       paymentTypes: Array.isArray(paymentTypes) ? paymentTypes : [],
//       printSettings: printSettings || null,
//       storeSettings: storeSettings || null,
//       storeTables: Array.isArray(storeTables) ? storeTables : [],
//       serviceCharge: serviceCharge || null,
//       currency: currencySymbol,
//       qrOrdersCount: totalQROrders,
//       isLoading: false,
//     }));

//   } catch (error) {
//     console.error("POS init failed:", error);

//     // Set default empty state to prevent further errors
//     setState(prev => ({
//       ...prev,
//       categories: [],
//       menuItems: [],
//       paymentTypes: [],
//       printSettings: null,
//       storeSettings: null,
//       storeTables: [],
//       serviceCharge: null,
//       currency: "",
//       qrOrdersCount: 0,
//       isLoading: false,
//     }));

//     toast.error("Failed to load POS data. Please refresh the page.");
//   }
// }

//   const _getQROrdersCount = async () => {
//     try {
//       const res = await getQROrdersCount();
//       if(res.status == 200) {
//         const data = res.data;

//         return data?.totalQROrders || 0;
//       }
//     } catch (error) {
//       console.error(error);
//       throw error;
//     }
//   }
//   const _initSocket = async () => {
//   try {
//     // Ensure socket is initialized (idempotent — will reuse if already connected)
//     initSocket();

//     // Wait up to 8s for socket to connect
//     try {
//       await waitForConnection(8000);
//     } catch (err) {
//       console.warn("⚠️ Socket connection timeout:", err?.message || err);
//     }

//     // Get the live socket instance
//     const s = getSocket();
//     if (!s || !s.connected) {
//       console.warn("⚠️ Socket not connected, skipping listener setup.");
//       return;
//     }

//     // Remove old listener if it exists (prevents duplication)
//     s.off("new_qrorder");

//     // Authenticate once connected
//     await safeEmit("authenticate", user.tenant_id, { wait: true, timeout: 5000 });
//     console.log("✅ Socket authenticated for tenant:", user.tenant_id);

//     // Listen for new QR orders
//     s.on("new_qrorder", async (payload) => {
//       console.log("📥 Received new_qrorder:", payload);
//       try {
//         const totalQROrders = await _getQROrdersCount();
//         setState((prevState) => ({
//           ...prevState,
//           qrOrdersCount: totalQROrders || 0,
//         }));
//       } catch (error) {
//         console.error("new_qrorder handler error:", error);
//       }
//     });

//     console.log("✅ Socket listener attached successfully.");
//   } catch (err) {
//     console.error("❌ _initSocket failed:", err);
//   }
// };


//   if(isLoading) {
//     return <Page className='px-4 py-3 flex flex-col min-h-0'>
//       <div className='mt-4 h-[calc(100vh-136px)] flex gap-4 skeleton'>
//         <div className='border border-restro-border-green-light rounded-2xl h-full w-[70%] overflow-y-auto'></div>
//         <div className='border border-restro-border-green-light rounded-2xl h-full w-[30%] relative flex flex-col'></div>
//       </div>
//     </Page>
//   }


//   // cart
//   function canPrepareMenuItem(menuItem, quantity = 1, selectedVariantId = null, selectedAddonIds = []) {
//     const usageMap = {};

//     menuItem.recipeItems.forEach((recipe) => {
//       const appliesToBase = recipe.variant_id === 0 && recipe.addon_id === 0;
//       const appliesToVariant = recipe.variant_id > 0 && recipe.variant_id == selectedVariantId;
//       const appliesToAddon = recipe.addon_id > 0 && selectedAddonIds.includes(recipe.addon_id.toString());

//       if (appliesToBase || appliesToVariant || appliesToAddon) {
//         const invId = recipe.inventory_item_id;
//         const requiredQty = parseFloat(String(String(recipe.recipe_quantity).replace(/,/g, "")).replace(/,/g, "")) * quantity;

//         if (!usageMap[invId]) {
//           usageMap[invId] = {
//             ingredient_title: recipe.ingredient_title,
//             total_required: 0,
//             current_quantity: parseFloat(String(String(recipe.current_quantity || 0).replace(/,/g, "")).replace(/,/g, "")),
//           };
//         }

//         usageMap[invId].total_required += requiredQty;
//       }
//     });

//     for (const invId in usageMap) {
//       const { ingredient_title, total_required, current_quantity } = usageMap[invId];
//       if (current_quantity < total_required) {
//         console.warn(
//           `Cannot prepare '${menuItem.title}' - Ingredient '${ingredient_title}' is insufficient`
//         );
//         return false;
//       }
//     }

//     return true;
//   }

//   function addItemToCart(item) {
//     const modifiedItem = {
//       ...item,
//       quantity: 1,
//       notes: null
//     }

//     if (!canPrepareMenuItem(item, 1)) {
//       toast.error(t('inventory.insufficient_stock_message_pos'));
//       return;
//     }

//     if(!cartItems) {
//       setState({
//         ...state,
//         cartItems: [modifiedItem]
//       })
//       return;
//     }
//     setState({
//       ...state,
//       cartItems: [...cartItems, modifiedItem]
//     })
//     playTapSound();
//   }

//   function removeItemFromCart(index) {
//     setState({
//       ...state,
//       cartItems: cartItems.filter((c,i)=> i !== index)
//     })
//     playTapSound();
//   }

//   function addCartItemQuantity(index, currentQuantity) {
//     const newQuantity = currentQuantity + 1;
//     const newCartItems = cartItems;

//     if (!canPrepareMenuItem(newCartItems[index], newQuantity, newCartItems[index].variant_id, newCartItems[index].addons_ids)) {
//       toast.error(t('inventory.insufficient_stock_message_pos'));
//       return;
//     }

//     newCartItems[index].quantity = newQuantity;

//     setState({
//       ...state,
//       cartItems: [...newCartItems]
//     });
//     playTapSound();
//   }
//   function minusCartItemQuantity(index, currentQuantity) {
//     const newQuantity = currentQuantity - 1;
//     let newCartItems = cartItems;

//     newCartItems[index].quantity = newQuantity;

//     if(newQuantity == 0) {
//       newCartItems = cartItems.filter((v, i)=>i!=index);
//     }

//     setState({
//       ...state,
//       cartItems: [...newCartItems]
//     });
//     playTapSound();
//   }
//   // cart

//   // order notes
//   const btnOpenNotesModal = (index, notes) => {
//     dialogNotesIndexRef.current.value = index;
//     dialogNotesTextRef.current.value = notes;
//     document.getElementById('modal-notes').showModal()
//   }
//   const btnAddNotes = () => {
//     const index = dialogNotesIndexRef.current.value;
//     const notes = dialogNotesTextRef.current.value || null;

//     const newCartItems = cartItems;
//     newCartItems[index].notes = notes;

//     setState({
//       ...state,
//       cartItems: newCartItems
//     })
//   };
//   // order notes

//   // category filter modal
//   const btnOpenCategoryFilterModal = () => {
//     categoryFilterDropdownRef.current.value = selectedCategory;
//     document.getElementById('modal-categories').showModal()
//   }
//   const btnApplyCategoryFilter = () => {
//     const selectedCategoryFromDropdown = categoryFilterDropdownRef.current.value || "";
//     setState({
//       ...state,
//       selectedCategory: selectedCategoryFromDropdown
//     })
//   }
//   const btnClearSelectedCategory = () => {
//     setState({
//       ...state,
//       selectedCategory: "all"
//     })
//   };
//   // category filter modal

//   // variant, addon modal

//   const resetVariantsAndAddons = () => {
//     const itemVariants = document.getElementsByName("variants");
//     itemVariants.forEach((item, index) => {
//       item.checked = index === 0;
//     });

//     const itemAddons = document.getElementsByName("addons");
//     itemAddons.forEach((item) => {
//       item.checked = false;
//     });
//   };

//   const btnOpenVariantAndAddonModal = (menuItemId) => {

//     resetVariantsAndAddons();

//     setState({
//       ...state,
//       selectedItemId: menuItemId
//     })
//     document.getElementById('modal-variants-addons').showModal()
//   }
//   const btnAddMenuItemToCartWithVariantsAndAddon = () => {
//     let price = 0;
//     let selectedVariantId = null;
//     const selectedAddonsId = [];

//     const itemVariants = document.getElementsByName("variants");
//     itemVariants.forEach((item)=>{
//       if(item.checked) {
//         selectedVariantId = item.value;
//         return;
//       }
//     })

//     const itemAddons = document.getElementsByName("addons");
//     itemAddons.forEach((item)=>{
//       if(item.checked) {
//         selectedAddonsId.push(item.value);
//       }
//     })

//     // get selected menu item
//     const selectedItem = menuItems.find((item)=>item.id == selectedItemId);

//     const addons = selectedItem?.addons || [];
//     const variants = selectedItem?.variants || [];

//     let selectedVariant = null;
//     if(selectedVariantId) {
//       selectedVariant = variants.find((v)=>v.id == selectedVariantId);
//       price = parseFloat(String(String(selectedVariant.price).replace(/,/g, "")).replace(/,/g, ""));
//     } else {
//       price = parseFloat(String(String(selectedVariant?.price ?? selectedItem.price).replace(/,/g, "")).replace(/,/g, ""))
//     }

//     let selectedAddons = [];
//     if(selectedAddonsId.length > 0) {
//       selectedAddons = selectedAddonsId.map((addonId)=>addons.find((addon)=>addon.id == addonId))
//       selectedAddons.forEach((addon)=>{
//         const addonPrice = parseFloat(String(String(addon.price).replace(/,/g, "")).replace(/,/g, ""));
//         price = price + addonPrice
//       });
//     }

//     const canPrepare = canPrepareMenuItem(selectedItem, 1/**quantity */, selectedVariantId, selectedAddonsId);

//     if (!canPrepare) {
//       toast.error(t('inventory.insufficient_stock_message_pos'));
//       return;
//     }

//     const itemCart = {...selectedItem, price: price, variant_id: selectedVariantId, variant: selectedVariant, addons_ids: selectedAddonsId, addons: selectedAddons}
//     addItemToCart(itemCart)
//   };
//   // variant, addon modal

//   // drafts
//   const btnOpenSaveDraftModal = () => {
//     if(cartItems.length == 0) {
//       toast.error(t('pos.empty_cart'));
//       return;
//     }
//     document.getElementById('modal-save-draft').showModal()
//   }
//   const btnAddtoDrafts = () => {
//     const drafts = getDrafts();

//     const nameRef = draftTitleRef.current.value || "";
//     const date = new Date().toLocaleString();

//     const draftItem = {
//       nameRef: nameRef,
//       date,
//       cart: cartItems
//     };

//     drafts.push(draftItem);

//     setDrafts(drafts);
//     setState({
//       ...state,
//       cartItems: []
//     })
//   };

//   const btnInitNewOrder = () => {
//     setState({
//       ...state,
//       cartItems: [],
//       customer: null,
//       customerType: "WALKIN",
//       selectedQrOrderItem: null,
//     })
//     playTapSound();
//   }

//   const btnOpenDraftsModal = () => {
//     const drafts = getDrafts();
//     setState({
//       ...state,
//       drafts: [...drafts]
//     });
//     document.getElementById("modal-drafts").showModal();
//   }

//   const btnDeleteDraftItem = index => {
//     const drafts = getDrafts();
//     const newDrafts = drafts.filter((v,i)=>i!=index);

//     setDrafts(newDrafts);

//     setState({
//       ...state,
//       drafts: [...newDrafts]
//     });
//   };

//   const btnClearDrafts = () => {
//     setDrafts([]);
//     setState({
//       ...state,
//       drafts: []
//     });
//   };
//   const btnSelectDraftItemToCart = draftItem => {
//     const {nameRef, date, cart} = draftItem;

//     setState({
//       ...state,
//       cartItems: [...cart]
//     });

//     document.getElementById("modal-drafts").close();
//   };
//   // drafts

//   // QR Menu Orders
//   const btnShowQROrdersModal = async () => {
//     try {
//       const res = await getQROrders();
//       if(res.status == 200) {
//         const data = res.data;
//         setState({
//           ...state,
//           qrOrders: [...data]
//         })
//         document.getElementById("modal-qrorders").showModal();
//       }
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   const btnClearQROrders = async () => {
//     const isConfirm = window.confirm(t('pos.delete_confirm'));
//     if(!isConfirm) {
//       return;
//     }
//     try {
//       toast.loading(t('pos.please_wait'));
//       const res = await cancelAllQROrders();
//       if(res.status == 200) {
//         toast.dismiss();
//         toast.success(res.data.message);
//         setState((prevState)=>({
//           ...prevState, qrOrders: [], qrOrdersCount: 0,
//         }))
//         playTapSound();
//       }
//     } catch (error) {
//       const message = error?.response?.data?.message || t('pos.getting_issues');
//       console.log(error);
//       toast.dismiss();
//       toast.error(message);
//     }
//   }
//   const btnCancelQROrder = async (orderId) => {
//     const isConfirm = window.confirm(t('pos.delete_confirm'));
//     if(!isConfirm) {
//       return;
//     }
//     try {
//       toast.loading(t('pos.please_wait'));
//       const res = await cancelQROrder(orderId);
//       if(res.status == 200) {
//         toast.dismiss();
//         toast.success(res.data.message);

//         const newQROrders = state.qrOrders.filter((item)=>item.id != orderId);
//         const newQROrderItem = state.qrOrdersCount - 1;

//         setState((prevState)=>({
//           ...prevState, qrOrders: [...newQROrders], qrOrdersCount: newQROrderItem,
//         }))
//       }
//     } catch (error) {
//       const message = error?.response?.data?.message || t('pos.getting_issues');
//       console.log(error);
//       toast.dismiss();
//       toast.error(message);
//     }
//   }
//   const btnSelectQROrder = (qrOrder) => {
//     console.log(qrOrder);

//     if(qrOrder.table_id) {
//       tableRef.current.value = qrOrder.table_id;
//     }

//     // const itemCart = {...selectedItem, price: price, variant_id: selectedVariantId, variant: selectedVariant, addons_ids: selectedAddonsId, addons: selectedAddons}

//     const modifiedCart = qrOrder.items.map((item)=>{
//       const id = item.item_id;

//       let selectedVariant = {
//         id: item.variant_id,
//         item_id: id,
//         price: item.variant_price,
//         title: item.variant_title,
//       }

//       return {
//         ...item,
//         id: id,
//         title: item.item_title,
//         addons_ids: item?.addons?.map((i)=>i.id),
//         variant: selectedVariant || null,
//         variant_id: item.variant_id || null,
//       }
//     })

//     setState({
//       ...state,
//       cartItems: modifiedCart,
//       selectedQrOrderItem: qrOrder.id,
//       customerType: qrOrder.customer_type,
//       customer: {phone: qrOrder.customer_id, name: qrOrder.customer_name},
//     })
//     playTapSound();

//     document.getElementById('modal-qrorders').close();
//   };
//   // QR MEnu Orders

//   // search customer modal
//   const btnOpenSearchCustomerModal = () => {
//     document.getElementById("modal-search-customer").showModal();
//   };
//   const btnClearSearchCustomer = () => {
//     setState({
//       ...state,
//       customerType: "WALKIN",
//       customer: null
//     })
//   }
//   const btnSearchCustomer = async () => {
//     const phone = searchCustomerRef.current.value;

//     if(!phone) {
//       toast.error(t('pos.please_provide_phone'));
//       return;
//     }

//     try {
//       toast.loading(t('pos.please_wait'));
//       const resp = await searchCustomer(phone);
//       toast.dismiss();
//       if(resp.status == 200) {
//         setState({
//           ...state,
//           customer: resp.data,
//           customerType: "CUSTOMER"
//         })
//         document.getElementById("modal-search-customer").close()
//       }

//     } catch (error) {
//       console.log(error);
//       const message = error.response.data.message || t('pos.error_getting_details');
//       toast.dismiss();
//       toast.error(message);
//     }
//   }
//   // search customer modal


//   // send to kitchen modal
//   const calculateOrderSummary = () => {
//     let itemsTotal = 0; // without tax - net amount
//     let taxTotal = 0;
//     let serviceChargeTotal = 0;
//     let payableTotal = 0;

//     cartItems.forEach((item)=>{
//       const taxId = item.tax_id;
//       const taxTitle = item.tax_title;
//       const taxRate = Number(String(String(item.tax_rate).replace(/,/g, "")).replace(/,/g, ""));
//       const taxType = item.tax_type; // inclusive or exclusive or NULL

//       const itemPrice = Number(String(String(item.price).replace(/,/g, "")).replace(/,/g, "")) * Number(String(String(item.quantity).replace(/,/g, "")).replace(/,/g, ""));

//       if (taxType == "exclusive") {
//         const tax = (itemPrice * taxRate) / 100;
//         const priceWithTax = itemPrice + tax;

//         taxTotal += tax;
//         itemsTotal += itemPrice;
//         payableTotal += priceWithTax;
//       } else if (taxType == "inclusive") {
//         const tax = itemPrice - (itemPrice * (100 / (100 + taxRate)));
//         const priceWithoutTax = itemPrice - tax;

//         taxTotal += tax;
//         itemsTotal += priceWithoutTax;
//         payableTotal += itemPrice;
//       } else {
//         itemsTotal += itemPrice;
//         payableTotal += itemPrice;
//       }
//     });

//     // Calculate Total Service charge % from items total
//     if (state.serviceCharge) {
//       let serviceCharge = (Number(String(String(itemsTotal).replace(/,/g, "")).replace(/,/g, "")) * Number(String(String(state.serviceCharge).replace(/,/g, "")).replace(/,/g, ""))) / 100;
//       serviceChargeTotal += serviceCharge;
//       payableTotal += serviceCharge;
//     }

//     return {
//       itemsTotal, taxTotal, serviceChargeTotal, payableTotal
//     }
//   };
//   const btnShowPayAndSendToKitchenModal = () => {
//     // calculate the item - total, tax, incl. tax, excl. tax, tax total, payable total

//     if(cartItems?.length == 0) {
//       toast.error(t('pos.empty_cart'));
//       return;
//     }

//     const { itemsTotal, taxTotal, serviceChargeTotal, payableTotal } = calculateOrderSummary();

//     setState({
//       ...state,
//       itemsTotal,
//       taxTotal,
//       serviceChargeTotal,
//       payableTotal
//     });
//     document.getElementById('modal-pay-and-send-kitchen-summary').showModal();
//   }
//   const btnPayAndSendToKitchen = async () => {
//     if(!state.selectedPaymentType) {
//       return toast.error(t('orders.select_payment_method'));
//     }
//     try {
//       const deliveryType = diningOptionRef.current.value;
//       const tableId = tableRef.current.value;
//       const customerType = state.customerType;
//       const customer = state.customer;

//       toast.loading(t('pos.please_wait'));
//       const res = await createOrderAndInvoice(cartItems, deliveryType, customerType, customer, tableId, state.itemsTotal, state.taxTotal, state.serviceChargeTotal , state.payableTotal, state.selectedQrOrderItem, state.selectedPaymentType);
//       toast.dismiss();
//       if(res.status == 200) {
//         const data = res.data;
//         toast.success(res.data.message);
//         document.getElementById("modal-pay-and-send-kitchen-summary").close();

//         const page_format = printSettings?.page_format || null;
//         const is_enable_print = printSettings?.is_enable_print || 0;

//         const paymentType = (paymentTypes?.find ? paymentTypes : []).find((v)=>v.id == state.selectedPaymentType);
//         let paymentMethodText;
//         if(paymentType) {
//           paymentMethodText = paymentType.title;
//         }

//         setDetailsForReceiptPrint({
//           cartItems, deliveryType, customerType, customer, tableId, currency, storeSettings, printSettings,
//           itemsTotal: state.itemsTotal,
//           taxTotal: state.taxTotal,
//           serviceChargeTotal:state.serviceChargeTotal,
//           payableTotal: state.payableTotal,
//           tokenNo: data.tokenNo,
//           orderId: data.orderId,
//           paymentMethod: paymentMethodText
//         });

//         sendNewOrderEvent(data.tokenNo, data.orderId);

//         let newQROrderItemCount = state.qrOrdersCount;
//         let newQROrders = [];
//         if(state.selectedQrOrderItem) {
//           newQROrderItemCount -= 1;
//           newQROrders = state?.qrOrders?.filter((item)=>item.id != state.selectedQrOrderItem);
//         }

//         setState((prev) => ({
//           ...prev,
//           cartItems: [],
//           tokenNo: data.tokenNo,
//           orderId: data.orderId,
//           selectedQrOrderItem: null,
//           qrOrders: newQROrders,
//           qrOrdersCount: newQROrderItemCount,
//           selectedPaymentType: null,
//         }))

//         _initPOS()

//         if(is_enable_print) {
//           setTimeout(()=>{
//             const receiptWindow = window.open("/print-receipt", "_blank", "toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=400,height=400");
//             receiptWindow.onload = (e) => {
//               setTimeout(()=>{
//                 receiptWindow.print();
//               },800)
//             }
//           }, 100)
//           return;
//         }

//         // show print token dialog
//         document.getElementById("modal-print-token").showModal();
//       }
//     } catch (error) {
//       const message = error?.response?.data?.message || t('pos.something_went_wrong');
//       console.error(error);

//       toast.dismiss();
//       toast.error(message);
//     }
//   };

//   const btnShowSendToKitchenModal = () => {
//     // calculate the item - total, tax, incl. tax, excl. tax, tax total, payable total

//     if(cartItems?.length == 0) {
//       toast.error(t('pos.empty_cart'));
//       return;
//     }

//     const { itemsTotal, taxTotal, serviceChargeTotal, payableTotal } = calculateOrderSummary();

//     setState({
//       ...state,
//       itemsTotal,
//       taxTotal,
//       serviceChargeTotal,
//       payableTotal
//     });
//     document.getElementById('modal-send-kitchen-summary').showModal();
//   }

//   const btnSendToKitchen = async () => {
//     try {
//       const deliveryType = diningOptionRef.current.value;
//       const tableId = tableRef.current.value;
//       const customerType = state.customerType;
//       const customer = state.customer;

//       toast.loading(t('pos.please_wait'));
//       const res = await createOrder(cartItems, deliveryType, customerType, customer, tableId, state.selectedQrOrderItem);
//       toast.dismiss();
//       if(res.status == 200) {
//         const data = res.data;
//         toast.success(res.data.message);
//         document.getElementById("modal-send-kitchen-summary").close();

//         const page_format = printSettings?.page_format || null;
//         const is_enable_print = printSettings?.is_enable_print || 0;

//         setDetailsForReceiptPrint({
//           cartItems, deliveryType, customerType, customer, tableId, currency, storeSettings, printSettings,
//           itemsTotal: state.itemsTotal,
//           taxTotal: state.taxTotal,
//           serviceChargeTotal:state.serviceChargeTotal,
//           payableTotal: state.payableTotal,
//           tokenNo: data.tokenNo,
//           orderId: data.orderId
//         });

//         sendNewOrderEvent(data.tokenNo, data.orderId);

//         let newQROrderItemCount = state.qrOrdersCount;
//         let newQROrders = [];
//         if(state.selectedQrOrderItem) {
//           newQROrderItemCount -= 1;
//           newQROrders = state?.qrOrders?.filter((item)=>item.id != state.selectedQrOrderItem);
//         }

//         setState((prev) => ({
//           ...prev,
//           cartItems: [],
//           tokenNo: data.tokenNo,
//           orderId: data.orderId,
//           selectedQrOrderItem: null,
//           qrOrders: newQROrders,
//           qrOrdersCount: newQROrderItemCount
//         }))

//         _initPOS()

//         if(is_enable_print) {
//           setTimeout(()=>{
//             const receiptWindow = window.open("/print-receipt", "_blank", "toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=400,height=400");
//             receiptWindow.onload = (e) => {
//               setTimeout(()=>{
//                 receiptWindow.print();
//               },800)
//             }
//           }, 100)
//           return;
//         }

//         // show print token dialog
//         document.getElementById("modal-print-token").showModal();
//       }
//     } catch (error) {
//       const message = error?.response?.data?.message || t('pos.something_went_wrong');
//       console.error(error);

//       toast.dismiss();
//       toast.error(message);
//     }
//   };
//   const btnPrintTokenOnly = () => {
//     const tokenWindow = window.open("/print-token", "_blank", "toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=400,height=400");
//     tokenWindow.onload = (e) => {
//       setTimeout(()=>{
//         tokenWindow.print();
//       }, 400)
//     }
//     return;
//   };
//   // send to kitchen modal


//   const setCustomer = (customer) => {

//     if(customer) {
//       setState({
//         ...state,
//         customer: {phone: customer.value, name:customer.label},
//         customerType: "CUSTOMER"
//       })
//       document.getElementById("modal-search-customer").close()
//     } else {
//       btnClearSearchCustomer();
//     }
//   }

// const searchCustomersAsync = (inputValue) => {
//   // Return a promise that ALWAYS resolves to an array
//   return new Promise((resolve) => {
//     // 1. Immediately validate
//     if (!inputValue || inputValue.trim() === '') {
//       resolve([]);
//       return;
//     }

//     const term = inputValue.trim();

//     // 2. Wrap everything in try/catch + setTimeout to avoid sync errors
//     setTimeout(async () => {
//       try {
//         const resp = await searchCustomer(term);

//         // 3. Validate response
//         if (!resp || resp.status !== 200 || !Array.isArray(resp.data)) {
//           resolve([]);
//           return;
//         }

//         // 4. Safely map
//         const options = resp.data
//           .filter(c => c && typeof c === 'object' && c.phone && c.name)
//           .map(c => ({
//             label: `${c.name} - (${c.phone})`,
//             value: c.phone,
//           }));

//         resolve(options);
//       } catch (error) {
//         console.error("searchCustomersAsync CRITICAL ERROR:", error);
//         resolve([]); // NEVER REJECT
//       }
//     }, 0);
//   });
// };
//   // search customer modal


//   return (
//     <Page className='px-4 py-3 flex flex-col min-h-0'>
//       <div className="flex md:items-center justify-between flex-col md:flex-row gap-2">
//         <h3>{t('pos.title')}</h3>
//         <div className='flex flex-wrap items-center gap-4'>
//           <button onClick={btnInitNewOrder} className = "text-sm rounded-lg border transition active:scale-95 hover:shadow-lg px-2 py-1 flex items-center gap-1 text-restro-text bg-restro-gray border-restro-border-green hover:bg-restro-button-hover">
//             <IconPlus size={18} stroke={iconStroke}  /> {t('pos.new_order')}
//           </button>

//           {/* QR Menu Orders */}
//           <button
//           onClick={btnShowQROrdersModal}
//           className = "relative text-sm rounded-lg border transition active:scale-95 hover:shadow-lg px-2 py-1 flex items-center gap-1 text-restro-text bg-restro-gray border-restro-border-green hover:bg-restro-button-hover">
//             <IconQrcode size={18} stroke={iconStroke}  /> {t('pos.qr_menu_orders')}

//             {state.qrOrdersCount > 0 && <div className='absolute -top-2 -right-2 w-4 h-4 rounded-full bg-red-500 text-white text-xs flex items-center justify-center'> {state.qrOrdersCount}
//             </div>}
//           </button>
//           {/* QR Menu Orders */}

//           <button onClick={btnOpenDraftsModal} className = "relative text-sm rounded-lg border transition active:scale-95 hover:shadow-lg text-gray-500 px-2 py-1 flex items-center gap-1 text-restro-text bg-restro-gray border-restro-border-green hover:bg-restro-button-hover">
//             <IconNotes size={18} stroke={iconStroke}  /> {t('pos.drafts_list')}
//           </button>

//           <Link to="/dashboard/orders" className = "relative text-sm rounded-lg border transition active:scale-95 hover:shadow-lg text-gray-500 px-2 py-1 flex items-center gap-1 text-restro-text bg-restro-gray border-restro-border-green hover:bg-restro-button-hover">
//             <IconArmchair size={18} stroke={iconStroke} /> {t('pos.table_orders')}
//           </Link>
//         </div>
//       </div>

//       <div className='mt-4 md:h-[calc(100vh-136px)] flex flex-col-reverse md:flex-row gap-4'>

//         {/* pos items */}
//         <div className = "h-full md:w-[70%] overflow-y-auto scrollbar-none border rounded-2xl border-restro-border-green">
//           {/* categories, search, toggle View*/}
//          <div className="bg-background flex gap-2 justify-between sticky top-0 w-full z-10 px-4 py-3 rounded-t-2xl">
//             <div className="flex overflow-x-auto space-x-2 text-sm custom-scroll-wrapper scrollbar scrollbar-none custom-scroll-div-horizon-smooth">
//               <div className="flex overflow-x-auto space-x-2 text-sm scrollbar scrollbar-none custom-scroll-div-horizon-smooth">
//                 <button
//                   className={`min-w-28 px-4 py-2 rounded-xl ${selectedCategory === "all"  ? theme === 'black' ? 'bg-restro-green-dark-mode text-white' : 'bg-restro-green text-white' : theme=== 'black' ? 'bg-restro-bg-seconday-dark-mode' : 'bg-gray-100 text-gray-600'}`}
//                   onClick={() => {
//                     setState({
//                       ...state,
//                       selectedCategory: 'all'
//                     })
//                   }}
//                 >
//                   {t('pos.all')}
//                 </button>
//                 {categories.filter((category) => category.is_enabled).map((category, index) => (
//                 <button
//                     key={index}
//                     className={`min-w-fit px-4 py-2 rounded-xl ${selectedCategory === category.id  ? theme === 'black' ? 'bg-restro-green-dark-mode text-white' : 'bg-restro-green text-white' : theme=== 'black' ? 'bg-restro-bg-seconday-dark-mode' : 'bg-gray-100 text-gray-600'}`}
//                     onClick={() => {
//                       setState({
//                         ...state,
//                         selectedCategory: category.id
//                       })
//                     }}
//                   >
//                     {category.title}
//                 </button>
//                 ))}
//               </div>
//             </div>
//             <div className="flex items-center gap-2">
//               <label className="flex items-center w-60 rounded-xl px-3 py-2 gap-2 bg-restro-gray border border-restro-border-green">
//                 <IconSearch size={18} stroke={iconStroke} /> 
//                  <input value={searchQuery} onChange={e=>setState({...state, searchQuery: e.target.value})} type="search" placeholder={t('appbar.search_placeholder')} className='w-full bg-transparent outline-none' />
//               </label>
//               <button
//               className={clsx(`px-3 py-2 rounded-xl`,
//                 theme === "black" ? state.view === "compact" ? "text-restro-green bg-restro-bg-seconday-dark-mode hover:bg-restro-bg-hover-dark-mode" : "text-gray-300 bg-restro-bg-seconday-dark-mode hover:bg-restro-bg-hover-dark-mode" : state.view === "compact" ? "text-restro-green bg-gray-100  hover:bg-gray-200" : "text-gray-400 bg-gray-100  hover:bg-gray-200"
// )}
//               onClick={() => {
//                 const newView = state.view === 'detailed' ? 'compact' : 'detailed';
//                 setState((prev) => ({
//                   ...prev,
//                   view: newView
//                 }));
//                 sessionStorage.setItem('view', newView);
//               }}>
//                 <IconLayout2 size={24} stroke={2}/>
//               </button>
//             </div>
//           </div>
//           {/* categories, search */}


//           {/* list */}
//           <div className='flex-1 h-full pt-3'>
//           {state.view == 'detailed' ?
//             <POSMenuItemDetailedView
//               menuItems={menuItems}
//               selectedCategory={selectedCategory}
//               categories={categories}
//               searchQuery={searchQuery}
//               currency={currency}
//               btnOpenVariantAndAddonModal={btnOpenVariantAndAddonModal}
//               addItemToCart={addItemToCart}
//             />:
//             <POSMenuItemCompactView
//               menuItems={menuItems}
//               selectedCategory={selectedCategory}
//               categories={categories}
//               searchQuery={searchQuery}
//               currency={currency}
//               btnOpenVariantAndAddonModal={btnOpenVariantAndAddonModal}
//               addItemToCart={addItemToCart}
//             />
//           }
//           </div>
//           {/* list */}


//         </div>
//         {/* pos items */}

//         {/* cart */}
//         <div className = "flex flex-col h-full md:w-[30%] relative border rounded-2xl border-restro-border-green">

//           <div className = "sticky w-full px-4 py-3 border-b rounded-t-2xl border-restro-border-green">
//             {/* search customer */}
//             <div onClick={btnOpenSearchCustomerModal} className="flex items-center gap-2">
//               <input value={customerType=="WALKIN"?t('pos.walkin_customer'):`${customer.name}`} type="text" placeholder={t('pos.search_customer')} className= "flex items-center gap-1 text-sm w-full px-4 py-2 transition active:scale-95 hover:shadow-lg border rounded-lg bg-restro-gray border-restro-border-green hover:bg-restro-button-hover outline-restro-border-green"/>
//               <button onClick={btnOpenSearchCustomerModal} className = "flex items-center justify-center w-9 h-9 transition active:scale-95 rounded-lg hover:shadow-lg bg-restro-gray border border-restro-border-green hover:bg-restro-button-hover">
//                 <IconSearch size={18} stroke={iconStroke} />
//               </button>
//             </div>
//             {/* search customer */}

//             {/* delivery type */}
//             <select ref={diningOptionRef} className="mt-3 text-sm w-full border rounded-lg px-4 py-2 justify-center bg-restro-gray border-restro-border-green hover:bg-restro-button-hover focus:outline-restro-border-green">
//               <option value="">{t('pos.select_dining_option')}</option>
//               <option value="dinein">{t('pos.dinein')}</option>
//               <option value="delivery">{t('pos.delivery')}</option>
//               <option value="takeaway">{t('pos.takeaway')}</option>
//             </select>
//             {/* delivery type */}

//             {/* table selection */}
//             <select ref={tableRef} className="mt-3 text-sm w-full border rounded-lg px-4 py-2 justify-center bg-restro-gray border-restro-border-green hover:bg-restro-button-hover focus:outline-restro-border-green">
//               <option value="">{t('pos.select_table')}</option>
//               {
//                 storeTables.map((table, index)=>{
//                   return <option value={table.id} key={index}>{table.table_title} ({table.seating_capacity} {t('pos.person')}) - {table.floor}</option>
//                 })
//               }
//             </select>
//             {/* table selection */}
//           </div>


//           {/* items */}
//           <div className='flex-1 flex flex-col gap-4 overflow-y-auto px-4 pb-36'>
//             <div className="h-1"></div>
//             {cartItems?.map((cartItem, i)=>{
//               const {quantity, notes, title, price, variant, addons} = cartItem;
//               const itemTotal = price * quantity;
//               return <div key={i} className="text-sm rounded-lg p-2 relative border border-restro-border-green">
//                 <p>#{i+1} {title} x {quantity}</p>
//                 <p className='mt-1'>{currency}{Number(String(String(price).replace(/,/g, "")).replace(/,/g, "")).toFixed(2)} <span className='text-xs'>x {quantity}</span> <span className='font-bold'>= {currency}{itemTotal.toFixed(2)}</span></p>
//                 {notes && <p className="mt-1 text-xs text-gray-400">
//                   {t('pos.notes')}: {notes}
//                 </p>
//                 }

//                 {variant && <p className="mt-1 text-xs text-gray-400">{t('pos.variant')}: {variant.title}</p>}
//                 {(addons && addons?.length > 0 ) && <p className="mt-1 text-xs text-gray-400">{t('pos.addons')}: {addons?.map((addon)=>(`${addon?.title}`)).filter(Boolean)?.join(", ")}</p>}

//                 <div className="flex items-center justify-between gap-2 w-full mt-4">
//                   <div className='flex items-center gap-2'>
//                     <button onClick={()=>{
//                       minusCartItemQuantity(i, quantity);
//                     }} className="btn btn-square btn-xs rounded-md bg-restro-gray hover:bg-restro-button-hover">
//                       <IconMinus stroke={iconStroke} size={18} />
//                     </button>
//                     <div className='w-8 h-8 flex items-center justify-center font-semibold'>
//                       {quantity}
//                     </div>
//                     <button onClick={()=>{
//                       addCartItemQuantity(i, quantity);
//                     }} className = "btn btn-square btn-xs rounded-md bg-restro-gray hover:bg-restro-button-hover">
//                       <IconPlus stroke={iconStroke} size={18} />
//                     </button>
//                   </div>
//                   <div>
//                     <button onClick={()=>{btnOpenNotesModal(i, notes)}} className = "flex items-center text-sm transition active:scale-95 hover:shadow-lg  px-2 py-1 gap-1 rounded-lg border border-restro-border-green bg-restro-gray hover:bg-restro-button-hover">
//                       <div><IconNote size={18} stroke={iconStroke}  /></div> <p>{t('pos.add_notes')}</p>
//                     </button>
//                   </div>
//                 </div>

//                 {/* action btn delete */}
//                 <button onClick={()=>{
//                   removeItemFromCart(i);
//                 }} className = "flex items-center justify-center absolute right-2 top-2 text-restro-red rounded-full w-6 h-6 transition bg-restro-gray hover:bg-restro-button-hover ">
//                   <IconTrash stroke={iconStroke} size={14} />
//                 </button>
//                 {/* action btn delete */}
//               </div>
//             })}
//           </div>
//           {/* items */}



//           {/* actions */}
//           <div className = "absolute w-full bottom-0 pb-4 rounded-b-2xl px-4 backdrop-blur border border-t border-b-0 border-l-0 border-r-0 border-restro-border-green">
//             <div className="flex items-center flex-col lg:flex-row gap-2 mt-4">
//               <button onClick={btnOpenSaveDraftModal} className = "flex items-center flex-1 lg:flex-none text-sm transition active:scale-95 hover:shadow-lg px-2 py-2 gap-1 text-restro-text border rounded-lg border-restro-border-green bg-restro-gray hover:bg-restro-button-hover">
//                 <IconDeviceFloppy size={18} stroke={iconStroke}  /> {t('pos.draft')}
//               </button>

//               <button onClick={btnShowSendToKitchenModal} className = "flex-1 flex justify-center items-center text-sm transition active:scale-95 hover:shadow-lg px-2 py-2  gap-1 text-restro-text border rounded-lg border-restro-border-green bg-restro-gray hover:bg-restro-button-hover">
//                 <div><IconChefHat size={18} stroke={iconStroke}  /></div> <p>{t('pos.send_to_kitchen')}</p>
//               </button>
//             </div>
//             <div className="mt-2">
//               <button onClick={btnShowPayAndSendToKitchenModal} className="flex items-center justify-center text-sm transition active:scale-95 hover:shadow-lg px-2 py-2 w-full gap-1 text-white border rounded-lg border-restro-border-green bg-restro-green hover:bg-restro-green-button-hover">
//                 <div><IconCash size={18} stroke={iconStroke}  /></div> <p>{t('pos.create_receipt_pay')}</p>
//               </button>
//             </div>
//           </div>
//           {/* actions */}

//         </div>
//         {/* cart */}

//       </div>


//       {/* dialog: notes */}
//       <dialog id="modal-notes" className="modal modal-bottom sm:modal-middle">
//         <div className = "modal-box border border-restro-border-green dark:rounded-2xl">
//           <div className='flex justify-between items-center'>
//             <h3 className="font-bold text-lg">{t('pos.add_notes')}</h3>
//             <button className = "text-restro-red p-2 rounded-full bg-restro-gray hover:bg-restro-button-hover" onClick={() => document.getElementById('modal-notes').close()}><IconX size={18} stroke={iconStroke}/></button>
//           </div>

//           <div className="my-4">
//             <input type="hidden" ref={dialogNotesIndexRef} />
//             <label htmlFor="dialogNotesText" className="mb-1 block text-gray-500 text-sm">{t('pos.notes')} <span className="text-xs text-gray-500">({t('pos.100_max_characters')})</span></label>
//             <input ref={dialogNotesTextRef} type="text" name="dialogNotesText" id='dialogNotesText' className='text-sm w-full rounded-lg px-4 py-2 border border-restro-border-green dark:bg-black focus:outline-restro-border-green' placeholder={t('pos.notes_placeholder')}/>
//           </div>

//           <div className="modal-action">
//             <form method="dialog" className='w-full'>
//               {/* if there is a button in form, it will close the modal */}
//               <button onClick={()=>{btnAddNotes();}} className='rounded-xl transition active:scale-95 hover:shadow-lg w-full px-4 py-3 text-white border border-restro-border-green bg-restro-green hover:bg-restro-green-button-hover'>{t('pos.save')}</button>
//             </form>
//           </div>
//         </div>
//       </dialog>
//       {/* dialog: notes */}

//       {/* dialog: category selection */}
//       <dialog id="modal-categories" className="modal modal-bottom sm:modal-middle">
//         <div className='modal-box border border-restro-border-green dark:rounded-2xl'>
//           <h3 className="font-bold text-lg">{t('pos.filters')}</h3>

//           <div className="my-4">
//             <label htmlFor="select_category" className='mb-1 text-sm w-full border rounded-lg px-2 py-2 block text-gray-500'>{t('pos.select_category')}</label>
//             <select ref={categoryFilterDropdownRef} type="text" name="select_category" id='select_category' className='text-sm w-full rounded-lg px-4 py-2 border border-restro-border-green dark:bg-black focus:outline-restro-border-green' placeholder={t('pos.select_category')} >
//               <option value="all">{t('pos.all')}</option>
//               {
//                 categories.filter((category) => category.is_enabled).map((category, index)=><option value={category.id} key={index}>{category.title}</option>)
//               }
//             </select>
//           </div>

//           <div className="modal-action">
//             <form method="dialog">
//               {/* if there is a button in form, it will close the modal */}
//               <button onClick={()=>{btnClearSelectedCategory()}} className="rounded-lg hover:bg-gray-200 transition active:scale-95 hover:shadow-lg px-4 py-3 bg-gray-200 text-gray-500">{t('pos.close')}</button>
//               <button onClick={()=>{btnApplyCategoryFilter();}} className="rounded-lg hover:bg-green-800 transition active:scale-95 hover:shadow-lg px-4 py-3 bg-restro-green text-white ml-3">{t('pos.apply')}</button>
//             </form>
//           </div>
//         </div>
//       </dialog>
//       {/* dialog: category selection */}

//       {/* dialog: variants & addons */}
//       <dialog id="modal-variants-addons" className="modal modal-bottom sm:modal-middle">
//         <div className='modal-box border border-restro-border-green dark:rounded-2xl'>
//           <div className='flex justify-between items-center'>
//             <h3 className="font-bold text-lg">{t('pos.select_variant_addons')}</h3>
//             <button className='text-red-500 p-2 rounded-full bg-restro-button-hover' onClick={() => document.getElementById('modal-variants-addons').close()}><IconX size={18} stroke={iconStroke}/></button>
//           </div>
//           <div className="my-8 flex gap-2">
//             <div className="flex-1">
//               <h3>{t('pos.variants')}</h3>
//               <div className="flex flex-col gap-2 mt-2">
//               {
//                 menuItems.find((item)=>item.id==selectedItemId)?.variants?.map((variant, index)=>{
//                   const {id, item_id, title, price} = variant;

//                   const fullItem = state.menuItems.find(item => item.id == selectedItemId);

//                   const variantRecipeItems = fullItem.recipeItems?.filter(
//                     r => r.variant_id === id && r.addon_id === 0
//                   );

//                   const isLowStock = variantRecipeItems?.some(
//                     (r) => parseFloat(String(String(r.current_quantity).replace(/,/g, "")).replace(/,/g, "")) <= parseFloat(String(String(r.min_quantity_threshold).replace(/,/g, "")).replace(/,/g, ""))
//                   );

//                   const quantitiesPossible = variantRecipeItems?.map(r => {
//                     const currentQty = parseFloat(String(String(r.current_quantity || "0").replace(/,/g, "")).replace(/,/g, ""));
//                     const requiredQty = parseFloat(String(String(r.recipe_quantity || "1").replace(/,/g, "")).replace(/,/g, ""));
//                     return Math.floor(currentQty / requiredQty);
//                   });

//                   const minItemsCanBeMade = quantitiesPossible?.length > 0
//                     ? Math.min(...quantitiesPossible)
//                     : null;

//                   return (
//                   <label key={index} className='cursor-pointer label justify-start gap-2'>
//                     <input type="radio" className='radio' name="variants" id="" value={id} defaultChecked={index==0} />
//                     <div>
//                     <span className="label-text">{title} - {currency}{price}</span>
//                     {isLowStock && (
//                         <div className="mt-1 bg-yellow-100 text-yellow-800 text-[10px] font-medium px-1 py-[1px] z-10 w-full flex flex-col items-center gap-[2px] rounded-md">
//                           <div className="flex items-center gap-1">
//                             <IconAlertTriangleFilled size={12} />
//                             <span>{t('inventory.low_stock')} - {minItemsCanBeMade} {t('inventory.qty')}</span>
//                           </div>
//                         </div>
//                       )}
//                     </div>
//                   </label>
//                 )})
//               }
//               </div>
//             </div>
//             <div className="flex-1">
//               <h3>{t('pos.addons')}</h3>
//               <div className="flex flex-col gap-2 mt-2">
//               {
//                 state.menuItems.find((item)=>item.id==selectedItemId)?.addons?.map((addon, index)=>{
//                   const {id, item_id, title, price} = addon;

//                   const fullItem = menuItems.find(item => item.id == selectedItemId);

//                   const addonRecipeItems = fullItem.recipeItems?.filter(
//                     (r) => r.addon_id === id && r.variant_id === 0
//                   );

//                   const quantitiesPossible = addonRecipeItems?.map(r => {
//                     const currentQty = parseFloat(String(String(r.current_quantity || "0").replace(/,/g, "")).replace(/,/g, ""));
//                     const requiredQty = parseFloat(String(String(r.recipe_quantity || "1").replace(/,/g, "")).replace(/,/g, ""));
//                     return Math.floor(currentQty / requiredQty);
//                   });

//                   const minItemsCanBeMade = quantitiesPossible?.length > 0
//                     ? Math.min(...quantitiesPossible)
//                     : null;

//                   const isLowStock = addonRecipeItems?.some(
//                     (r) => parseFloat(String(String(r.current_quantity).replace(/,/g, "")).replace(/,/g, "")) <= parseFloat(String(String(r.min_quantity_threshold).replace(/,/g, "")).replace(/,/g, ""))
//                   );

//                   return (
//                   <label key={index} className='cursor-pointer label justify-start gap-2'>
//                     <input type="checkbox" name="addons" id="" className='checkbox  checkbox-sm' value={id} />
//                     <div>
//                     <span className="label-text">{title} (+{currency}{price})</span>
//                     {isLowStock && (
//                       <div className="mt-1 bg-yellow-100 text-yellow-800 text-[10px] font-medium px-1 py-[1px] z-10 w-full flex flex-col items-center gap-[2px] rounded-md">
//                         <div className="flex items-center gap-1">
//                           <IconAlertTriangleFilled size={12} />
//                           <span>{t('inventory.low_stock')} - {minItemsCanBeMade} {t('inventory.qty')}</span>
//                         </div>
//                       </div>
//                     )}
//                     </div>
//                   </label>
//                 )})
//               }
//               </div>
//             </div>
//           </div>

//           <div className="modal-action">
//             <form method="dialog" className="w-full flex gap-2">
//               {/* if there is a button in form, it will close the modal */}
//               <button onClick={()=>{btnAddMenuItemToCartWithVariantsAndAddon()}} className='transition active:scale-95 hover:shadow-lg w-full px-4 py-3 text-white rounded-xl border border-restro-border-green bg-restro-green hover:bg-restro-green-button-hover'>{t('pos.add')}</button>
//             </form>
//           </div>
//         </div>
//       </dialog>
//       {/* dialog: variants & addons */}


//       {/* dialog: save draft */}
//       <dialog id="modal-save-draft" className="modal modal-bottom sm:modal-middle">
//         <div className='modal-box border border-restro-border-green dark:rounded-2xl'>
//           <h3 className="font-bold text-lg">{t('pos.save_cart_items_to_drafts')}</h3>

//           <div className="my-4">
//             <label htmlFor="draftTitleRef" className="mb-1 block text-gray-500 text-sm">{t('pos.reference')}</label>
//             <input ref={draftTitleRef} type="text" name="draftTitleRef" id='draftTitleRef' className='text-sm w-full rounded-lg px-4 py-2 border border-restro-border-green dark:bg-black focus:outline-restro-border-green' placeholder={t('pos.enter_reference_name')} />
//           </div>

//           <div className="modal-action">
//             <form method="dialog">
//               {/* if there is a button in form, it will close the modal */}
//               <button className='btn transition active:scale-95 hover:shadow-lg px-4 py-3 flex-1 items-center justify-center align-center rounded-xl border border-restro-border-green bg-restro-card-bg hover:bg-restro-button-hover text-restro-text'>{t('pos.close')}</button>
//               <button onClick={()=>{btnAddtoDrafts();}} className='rounded-xl transition active:scale-95 hover:shadow-lg px-4 py-3 text-white ml-3 border border-restro-border-green bg-restro-green hover:bg-restro-green-button-hover'>{t('pos.save')}</button>
//             </form>
//           </div>
//         </div>
//       </dialog>
//       {/* dialog: save draft */}

//       {/* dialog: drafts list */}
//       <dialog id="modal-drafts" className="modal modal-bottom sm:modal-middle">
//         <div className='modal-box p-0 border border-restro-border-green dark:rounded-2xl'>
//           <div className='flex justify-between items-center sticky top-0 backdrop-blur px-6 py-4 bg-restro-gray'>
//             <h3 className="font-bold text-lg">{t('pos.drafts')}</h3>
//             <form method="dialog" className='flex gap-1'>
//               {/* if there is a button in form, it will close the modal */}
//               <button onClick={btnClearDrafts} className='transition active:scale-95 text-red-500 p-2 rounded-ful rounded-full w-9 h-9 flex items-center justify-center hover:bg-restro-button-hover'><IconClearAll stroke={iconStroke} /></button>
//               <button className='transition active:scale-95 text-restro-text p-2 rounded-ful rounded-full w-9 h-9 flex items-center justify-center hover:bg-restro-button-hover'><IconX stroke={iconStroke} /></button>
//             </form>
//           </div>

//           <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 px-6 pb-6 pt-4">
//             {drafts.map((draftItem, index)=>{
//               const {nameRef, date, cart} = draftItem;

//               return <div key={index} className='flex items-center gap-1 rounded-2xl p-2 border border-restro-border-green'>
//                 <div className='w-12 h-12 rounded-full flex items-center justify-center text-restro-text bg-restro-bg-gray'>
//                   <IconClipboardList stroke={iconStroke} />
//                 </div>
//                 <div className='flex-1'>
//                   <p>{t('pos.ref')}: {nameRef}</p>
//                   <p className='text-xs'>{cart?.length} {t('pos.cart_items')}</p>
//                   <p className='text-xs text-gray-500'>{date}</p>
//                 </div>
//                 <div className="flex flex-col gap-1">
//                   <button onClick={()=>{btnSelectDraftItemToCart(draftItem)}}  className='rounded-full transition active:scale-95 w-6 h-6 flex items-center justify-center text-restro-text bg-restro-gray hover:bg-restro-button-hover'><IconPencil size={14} stroke={iconStroke} /></button>

//                   <button onClick={()=>{btnDeleteDraftItem(index)}} className='rounded-full transition active:scale-95 text-red-500 w-6 h-6 flex items-center justify-center bg-restro-gray hover:bg-restro-button-hover'><IconTrash size={14} stroke={iconStroke} /></button>
//                 </div>
//               </div>
//             })}
//           </div>


//         </div>
//       </dialog>
//       {/* dialog: drafts list */}

//       <DialogAddCustomer defaultValue={state.addCustomerDefaultValue} onSuccess={(phone, name)=>{
//         setCustomer({value: phone, label: `${name} - (${phone})`})
//         document.getElementById("modal-search-customer").close();
//       }} />

//       {/* dialog: search customer */}
//       <dialog id="modal-search-customer" className="modal modal-bottom sm:modal-middle">
//       <div className='modal-box border border-restro-border-green dark:rounded-2xl h-96'>
//           <div className="flex items-center justify-between">

//             <h3 className="font-bold text-lg">{t('pos.search_customer')}</h3>
//             <form method="dialog">
//               <button onClick={btnClearSearchCustomer} className='btn btn-circle btn-sm text-restro-text border-none bg-restro-gray hover:bg-restro-button-hover'><IconRotate size={18} stroke={iconStroke}/></button>
//               <button className='ml-2 btn btn-circle btn-sm text-red-500 border-none bg-restro-gray hover:bg-restro-button-hover'><IconX size={18} stroke={iconStroke}/></button>
//             </form>
//           </div>

//           <div className="my-4 flex items-end gap-2">
//             <div className='flex-1'>
//               <label htmlFor="searchCustomerRef" className="mb-1 block text-gray-500 text-sm">{t('pos.search_customer')}</label>
//               {/* <input ref={searchCustomerRef} type="search" name="searchCustomerRef" id='searchCustomerRef' className="text-sm w-full border rounded-lg px-4 py-2 bg-gray-50 outline-restro-border-green-light" placeholder="Enter Customer Phone here..." /> */}
//               <AsyncCreatableSelect
//                 menuPlacement='auto'
//                 loadOptions={searchCustomersAsync}
//                 isClearable
//                 noOptionsMessage={(v)=>{return t('pos.type_to_find')}}
//                 onChange={(v)=>{
//                   setCustomer(v);
//                 }}
//                 onCreateOption={(inputValue)=>{
//                   setState({
//                     ...state,
//                     addCustomerDefaultValue: inputValue,
//                   })
//                   document.getElementById("modal-add-customer").showModal();
//                 }}
//                 styles={{
//                   control: (base) => ({
//                     ...base,
//                     backgroundColor: theme === "black" ? "" : "",
//                     borderRadius: "0.5rem",
//                     borderColor: theme === "black" ? "#232323" : "#f3f4f6",
//                     height: 40,
//                     boxShadow: "none",
//                     color: theme === "black" ? "#ffffff" : "#111827", // text color
//                     "&:hover": {
//                       borderColor: theme === "black" ? "#23233" : "#9ca3af",
//                     },
//                   }),
//                   menu: (base) => ({
//                     ...base,
//                     borderRadius: "0.5rem",
//                   }),
//                   menuList: (base) => ({
//                     ...base,
//                     maxHeight: 150,
//                     overflowY: "auto",
//                     borderRadius: "0.5rem",
//                     backgroundColor: theme === "black" ? "#232323" : "white",
//                   }),
//                   option: (base, state) => ({
//                     ...base,
//                     backgroundColor: state.isFocused
//                       ? theme === "black"
//                         ? "#292929"
//                         : "#e5e7eb"
//                       : theme === "black"
//                         ? "#232323"
//                         : "white",
//                     color: theme === "black" ? "#f9fafb" : "#111827",
//                     "&:active": {
//                       backgroundColor: theme === "black" ? "#6b7280" : "#d1d5db",
//                     },
//                   }),
//                   indicatorSeparator: (base) => ({
//                     ...base,
//                     backgroundColor: theme === "black" ? "#ffffff" : "#d1d5db", // divider color based on theme
//                   }),
//                 }}
//               />
//             </div>
//           </div>
//         </div>
//       </dialog>
//       {/* dialog: search customer */}

//       {/* dialog: send to kitchen summary */}
//       <dialog id="modal-send-kitchen-summary" className="modal modal-bottom sm:modal-middle">
//         <div className='modal-box border border-restro-border-green dark:rounded-2xl'>
//           <div className="flex items-center justify-between gap-4">
//             <h3 className="font-bold text-lg">{t('pos.send_order_to_kitchen')}</h3>
//             <form method='dialog'>
//               <button className='text-red-500 p-2 rounded-full bg-restro-gray hover:bg-restro-button-hover'><IconX size={18} stroke={iconStroke} /></button>
//             </form>
//           </div>

//           <div className="my-8 space-y-4 px-1">
//             {[
//               { label: t('pos.items_net_total'), value: state.itemsTotal },
//               { label: t('pos.tax_total'), value: state.taxTotal, prefix: "+" },
//               { label: t('pos.service_charge_total'), value: state.serviceChargeTotal, prefix: "+" },
//             ].map(({ label, value, prefix = "" }, index) => (
//               <div key={index} className='flex items-center justify-between text-restro-text'>
//                 <p>{label}</p>
//                 <p className="text-lg">
//                   {prefix}{currency}{value.toFixed(2)}
//                 </p>
//               </div>
//             ))}

//             <div className="flex items-center justify-between border-t border-gray-300 dark:border-restro-bg-gray pt-2 mt-2">
//               <p className="text-xl font-medium">{t('pos.payable_total')}</p>
//               <p className="text-xl font-bold text-restro-green">
//                 {currency}{state.payableTotal.toFixed(2)}
//               </p>
//             </div>
//           </div>


//           <div className="modal-action">
//             <form method="dialog" className="w-full">
//               {/* if there is a button in form, it will close the modal */}
//               <button onClick={btnSendToKitchen} className='w-full rounded-xl transition active:scale-95 hover:shadow-lg px-4 py-3 text-white border border-restro-border-green bg-restro-green hover:bg-restro-green-button-hover'>{t('pos.send_to_kitchen')}</button>
//             </form>
//           </div>
//         </div>
//       </dialog>
//       {/* dialog: send to kitchen summary */}

//       {/* dialog: collect payment & send to kitchen summary */}
//       <dialog id="modal-pay-and-send-kitchen-summary" className="modal modal-bottom sm:modal-middle">
//         <div className='modal-box border border-restro-border-green dark:rounded-2xl'>
//           <div className="flex items-center justify-between">
//             <h3 className="font-bold text-lg">{t('pos.collect_payment_send_order_to_kitchen')}</h3>
//             <form method='dialog'>
//               <button className='text-red-500 p-2 rounded-full bg-restro-gray hover:bg-restro-button-hover'><IconX size={18} stroke={iconStroke} /></button>
//             </form>
//           </div>

//           <div className="my-8 space-y-4 px-1">
//             {[
//               { label: t('pos.items_net_total'), value: state.itemsTotal },
//               { label: t('pos.tax_total'), value: state.taxTotal, prefix: "+" },
//               { label: t('pos.service_charge_total'), value: state.serviceChargeTotal, prefix: "+" },
//             ].map(({ label, value, prefix = "" }, index) => (
//               <div key={index} className='flex items-center justify-between' text-restro-text>
//                 <p>{label}</p>
//                 <p className="text-lg">
//                   {prefix}{currency}{value.toFixed(2)}
//                 </p>
//               </div>
//             ))}

//             <div className="flex items-center justify-between border-t border-gray-300 dark:border-restro-bg-gray pt-2 mt-2">
//               <p className="text-xl font-medium">{t('pos.payable_total')}</p>
//               <p className="text-xl font-bold text-restro-green">
//                 {currency}{state.payableTotal.toFixed(2)}
//               </p>
//             </div>
//           </div>

//           <div
//             className={`grid gap-2 grid-cols-3`
//           }
//           >
//             {(paymentTypes||[]).map((paymentType, i)=>{
//               const uniqueId = `icon-${paymentType?.id}`;
//               return <label key={i} className=''>
//                 <input
//                 checked={state?.selectedPaymentType == paymentType?.id}
//                 onChange={e=>{
//                   setState({
//                     ...state,
//                     selectedPaymentType: e.target.value,
//                   });
//                 }} type="radio" name="payment_type" id={uniqueId} value={paymentType?.id} className='peer hidden' />
//                 <label htmlFor={uniqueId} className='border dark:border-restro-gray rounded-2xl flex items-center justify-center gap-1 flex-col px-4 py-3 peer-checked:border-restro-green peer-checked:text-restro-green peer-checked:font-bold cursor-pointer transition'>
//                   {paymentType?.icon ? <div>{PAYMENT_ICONS[paymentType?.icon]}</div>:<></>}
//                   <p className='text-xs'>{paymentType.title}</p>
//                 </label>
//               </label>
//             })}
//           </div>

//           <div className="modal-action flex items-center justify-center w-full">

//             {/* if there is a button in form, it will close the modal */}
//             <button onClick={()=>{btnPayAndSendToKitchen();}} className='rounded-xl transition active:scale-95 hover:shadow-lg px-4 py-3 text-white w-full fborder border-restro-border-green bg-restro-green hover:bg-restro-green-button-hover'>{t('pos.collect_payment_send_to_kitchen')}</button>

//           </div>
//         </div>
//       </dialog>
//       {/* dialog: collect payment & send to kitchen summary */}

//       {/* dialog: print-token */}
//       <dialog id="modal-print-token" className="modal modal-bottom sm:modal-middle">
//         <div className='modal-box border border-restro-border-green dark:rounded-2xl'>
//           <h3 className="font-bold text-lg text-center">{t('pos.order_sent_to_kitchen')}</h3>

//           <div className="my-8 mx-auto w-fit">
//             <div className="flex items-center gap-2">
//               <div className="w-12 h-12 flex items-center justify-center bg-restro-green text-white rounded-full">
//                 <IconCheck stroke={iconStroke} size={32} />
//               </div>
//               <p className="font-bold text-5xl">#{state?.tokenNo}</p>
//             </div>

//             <p className="text-sm mt-4 text-center">{t('pos.order_id')}: {state?.orderId}</p>
//           </div>

//           <div className="modal-action justify-center">
//             <form method="dialog">
//               {/* if there is a button in form, it will close the modal */}
//               <button className='btn transition active:scale-95 hover:shadow-lg px-4 py-3 flex-1 items-center justify-center align-center rounded-xl border border-restro-border-green bg-restro-card-bg hover:bg-restro-button-hover text-restro-text'>{t('pos.close')}</button>
//               <button onClick={btnPrintTokenOnly}className='rounded-xl transition active:scale-95 hover:shadow-lg px-4 py-3 text-white ml-3 border border-restro-border-green bg-restro-green hover:bg-restro-green-button-hover'>{t('pos.print_token')}</button>
//             </form>
//           </div>
//         </div>
//       </dialog>
//       {/* dialog: print-token */}

//       {/* dialog: qrorders */}
//       <dialog id="modal-qrorders" className="modal modal-bottom sm:modal-middle">
//         <div className='modal-box border border-restro-border-green dark:rounded-2xl p-0'>
//           <div className="flex justify-between items-center sticky top-0 px-6 py-4">
//             <h3 className="font-bold text-lg">{t('pos.qr_orders')}</h3>
//             <form method="dialog" className='flex gap-2'>
//               {/* if there is a button in form, it will close the modal */}
//               <button onClick={btnClearQROrders} className="rounded-full hover:bg-red-200 transition active:scale-95 bg-red-50 dark:bg-red-500 dark:text-white text-red-500 w-9 h-9 flex items-center justify-center"><IconClearAll stroke={iconStroke} /></button>
//               <button className="rounded-full hover:bg-gray-200 dark:hover:bg-black transition active:scale-95 bg-gray-100 dark:bg-restro-gray text-gray-500 dark:text-white w-9 h-9 flex items-center justify-center"><IconX stroke={iconStroke} /></button>
//             </form>
//           </div>

//           <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 px-6 pb-6">
//             {state?.qrOrders?.map((qrOrder, index)=>{
//               const { customer_type, customer_id, customer_name, table_id, table_title, items, id } = qrOrder;

//               return <div key={index} className='flex items-center gap-1 rounded-2xl p-2 border dark:border-restro-gray'>
//                 <div className='w-12 h-12 rounded-full bg-gray-100 dark:bg-restro-gray dark:text-white text-gray-500 flex items-center justify-center'>
//                   <IconClipboardList stroke={iconStroke} />
//                 </div>
//                 <div className='flex-1'>
//                   <div className="flex items-center gap-1 text-xs text-gray-500">
//                     <IconArmchair2 stroke={iconStroke} size={14} />
//                     <p className=''>{table_title || "N/A"}</p>
//                   </div>
//                   <div className="flex items-center gap-1 text-xs">
//                     <IconUser stroke={iconStroke} size={14} />
//                     <p className=''>{customer_type == "WALKIN" ? "WALKIN" : customer_name}</p>
//                   </div>
//                   <p className='text-xs'>{items?.length} {t('pos.cart_items')}</p>
//                 </div>
//                 <div className="flex flex-col gap-1">
//                   <button onClick={()=>{btnSelectQROrder(qrOrder)}} className='rounded-full transition active:scale-95 w-6 h-6 flex items-center justify-center text-restro-text bg-restro-gray hover:bg-restro-button-hover'><IconPencil size={14} stroke={iconStroke} /></button>

//                   <button onClick={()=>{btnCancelQROrder(id)}} className='rounded-full transition active:scale-95 text-red-500 w-6 h-6 flex items-center justify-center bg-restro-gray hover:bg-restro-button-hover'><IconTrash size={14} stroke={iconStroke} /></button>
//                 </div>
//               </div>
//             })}
//           </div>
//         </div>
//       </dialog>
//       {/* dialog: qrorders */}
//     </Page>
//   )
// }

import { QRCodeSVG } from 'qrcode.react';
import { useTranslation } from 'react-i18next';
import Page from "../components/Page";
import ApiClient from "../helpers/ApiClient";
import { IconPlus, IconNotes, IconArmchair, IconScreenShare, IconSearch, IconDeviceFloppy, IconChefHat, IconCash, IconMinus, IconNote, IconTrash, IconFilter, IconPhoto, IconFilterFilled, IconClipboardList, IconX, IconClearAll, IconPencil, IconCheck, IconCarrot, IconRotate, IconQrcode, IconArmchair2, IconUser, IconCategory, IconGridDots, IconLayoutGrid, IconListDetails, IconListTree, IconMenu4, IconLayoutGridFilled, IconMenu2, IconLayoutList, IconLayout2, IconLayout2Filled, IconAlertTriangleFilled, IconGift, IconBed, IconReceipt, IconDiscount, IconCalculator, IconCreditCard, IconScale } from "@tabler/icons-react";
import { VITE_BACKEND_SOCKET_IO, iconStroke } from "../config/config";
import { cancelAllQROrders, cancelQROrder, createOrder, updateOrder, createOrderAndInvoice, getDrafts, getQROrders, getQROrdersCount, initPOS, setDrafts } from "../controllers/pos.controller";
import { CURRENCIES } from '../config/currencies.config';
import { PAYMENT_ICONS } from "../config/payment_icons";
import { toast } from "react-hot-toast";
import { searchCustomer } from '../controllers/customers.controller';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { setDetailsForReceiptPrint } from '../helpers/ReceiptHelper';
import { SocketContext } from "../contexts/SocketContext";
import { initSocket } from '../utils/socket';
import { getImageURL } from '../helpers/ImageHelper';
import { getUserDetailsInLocalStorage } from '../helpers/UserDetails';
import AsyncCreatableSelect from 'react-select/async-creatable';
import DialogAddCustomer from '../components/DialogAddCustomer';
import POSMenuItemDetailedView from '../components/POSMenuItemDetailedView';
import POSMenuItemCompactView from '../components/POSMenuItemCompactView';
import { clsx } from "clsx";
import { useTheme } from '../contexts/ThemeContext';
import { playQROrderSound, playNewOrderSound, unlockAudio } from '../helpers/SoundHelper';

export default function POSPage() {
  const { t } = useTranslation();
  const user = getUserDetailsInLocalStorage();
  const { socket, isSocketConnected } = useContext(SocketContext);
  const navigate = useNavigate();
  const location = useLocation();
  const editOrderData = location.state?.editOrder || null;
  const { theme } = useTheme();
  const diningOptionRef = useRef();
  const tableRef = useRef();
  const [diningOption, setDiningOption] = useState("");
  const roomRef = useRef();

  // dialog: notes ref
  const dialogNotesIndexRef = useRef();
  const dialogNotesTextRef = useRef();
  // dialog: notes ref

  // dialog: category filter
  const categoryFilterDropdownRef = useRef(null);
  // dialog: category filter

  // dialog: category filter
  const draftTitleRef = useRef(null);
  // dialog: category filter

  // dialog: search customer
  const searchCustomerRef = useRef(null);
  // dialog: search customer

  const lastPlacedOrderIdRef = useRef(null);

  const tapSound = new Audio("/tap.mp3");

  const [state, setState] = useState({
    view: "detailed",
    categories: [],
    menuItems: [],
    paymentTypes: [],
    printSettings: null,
    storeSettings: null,
    storeTables: [],
    serviceCharge: null,
    currency: "",
    isLoading: true,
    rooms: [],

    cartItems: [],
    customerType: "WALKIN",
    customer: null,
    addCustomerDefaultValue: null,

    searchQuery: "",
    selectedCategory: "all",

    selectedItemId: null,

    drafts: [],

    itemsTotal: 0,
    taxTotal: 0,
    serviceChargeTotal: 0,
    payableTotal: 0,

    orderId: null,
    tokenNo: null,

    qrOrdersCount: 0,
    qrOrders: [],
    selectedQrOrderItem: null,

    selectedPaymentType: null,
    cashTendered: 0,

    loyaltySettings: null,
    customerLoyalty: null,
    loyaltyRedemptionAmount: 0,
    loyaltyPointsRedeemed: 0,
    loyaltyItemsRedeemed: 0,
    multiPayments: [],
    discountType: "fixed", // "fixed" or "percent"
  });

  useEffect(() => {
    const fetchCustomerLoyalty = async () => {
      if (state.customer && state.customer.phone) {
        try {
          const data = await getCustomerLoyalty(state.customer.phone);
          setState(prev => ({ ...prev, customerLoyalty: data }));
        } catch (error) {
          console.error("Failed to fetch customer loyalty", error);
        }
      } else {
        setState(prev => ({ ...prev, customerLoyalty: null, loyaltyRedemptionAmount: 0, loyaltyPointsRedeemed: 0, loyaltyItemsRedeemed: 0 }));
      }
    };
    fetchCustomerLoyalty();
  }, [state.customer]);

  // Load edit order data after POS initializes
  useEffect(() => {
    if (!editOrderData || state.isLoading || state.menuItems.length === 0) return;

    // Map order items back to cartItem format using menuItems from POS init
    const loadedCartItems = editOrderData.items.map(item => {
      // Find the full menu item to get recipeItems, addons, etc.
      const menuItem = state.menuItems.find(m => m.id === item.item_id) || {};
      return {
        ...menuItem,
        id: item.item_id,
        title: item.item_title || menuItem.title,
        price: item.price,
        quantity: item.quantity,
        notes: item.notes || null,
        variant_id: item.variant_id || null,
        addons_ids: item.addons ? item.addons.map(a => a.id) : [],
        is_complementary: item.is_complementary || 0,
        recipeItems: menuItem.recipeItems || [],
        variants: menuItem.variants || [],
        addons: menuItem.addons || [],
        // Keep variant label for display
        variant: item.variant_id ? { id: item.variant_id, title: item.variant_title } : null,
        status: item.status,
      };
    });

    // Set table and dining option if available
    if (editOrderData.tableId && tableRef.current) {
      tableRef.current.value = editOrderData.tableId;
    }
    if (editOrderData.deliveryType && diningOptionRef.current) {
      diningOptionRef.current.value = editOrderData.deliveryType;
    }

    setState(prev => ({
      ...prev,
      cartItems: loadedCartItems,
      editOrderId: editOrderData.orderId,
      customerType: editOrderData.customerType || 'WALKIN',
      customer: editOrderData.customer?.phone ? editOrderData.customer : null,
    }));

    toast.success(`Editing Order #${editOrderData.orderId}`, { icon: '✏️' });
  }, [state.isLoading, state.menuItems.length]);

  useEffect(() => {
    _initPOS();
  }, []);

  useEffect(() => {
    const { itemsTotal, taxTotal, serviceChargeTotal, payableTotal } = calculateOrderSummary();
    setState(prev => ({
      ...prev,
      itemsTotal,
      taxTotal,
      serviceChargeTotal,
      payableTotal
    }));
  }, [state.cartItems, state.discount, state.serviceCharge]);

  const { categories, menuItems, paymentTypes, printSettings, storeSettings, storeTables, currency, cartItems, searchQuery, selectedCategory, selectedItemId, drafts, customer, customerType, isLoading } = state;



  function sendNewOrderEvent(tokenNo, orderId) {
    if (isSocketConnected) {
      socket.emit('new_order_backend', { tokenNo, orderId }, user.tenant_id);
    } else {
      // Handle disconnected state (optional)
      initSocket();
      socket.emit('new_order_backend', { tokenNo, orderId }, user.tenant_id);
    }
  }

  function playTapSound() {
    tapSound.play();
  }

  async function _initPOS() {
    try {
      const res = await initPOS();
      let totalQROrders = 0;

      if (res.status == 200) {
        const data = res.data;

        const currency = CURRENCIES.find((c) => c.cc == data?.storeSettings?.currency);

        try {
          totalQROrders = await _getQROrdersCount();
        } catch (error) {
          console.log(error);
        }

        const savedView = sessionStorage.getItem('view') || 'detailed';

        // Fetch auxiliary data in parallel
        const [loyaltySettings, rooms] = await Promise.all([
          ApiClient.get("/loyalty/settings").then(r => r.data).catch(() => null),
          ApiClient.get("/rooms/list-basic").then(r => r.data).catch(() => [])
        ]);

        if (data.categories && Array.isArray(data.categories)) {
          try { localStorage.setItem('cached_categories', JSON.stringify(data.categories)); } catch(e) {}
        }

        setState((prev) => ({
          ...prev,
          view: savedView,
          categories: data.categories,
          menuItems: data.menuItems,
          paymentTypes: data.paymentTypes,
          printSettings: data.printSettings,
          storeSettings: data.storeSettings,
          storeTables: data.storeTables,
          serviceCharge: data.serviceCharge,
          currency: currency?.symbol || "",
          qrOrdersCount: totalQROrders || 0,
          isLoading: false,
          loyaltySettings,
          rooms,
        }));
      } else {
        setState((prev) => ({
          ...prev,
          isLoading: false,
        }));
        toast.error("Failed to load POS data. Please refresh.");
      }
    } catch (error) {
      console.error(error);
      setState((prev) => ({
        ...prev,
        isLoading: false,
      }));
      toast.error("Error connecting to server. Please try again.");
    }
  }

  async function _getQROrdersCount() {
    try {
      const res = await getQROrdersCount();
      if (res.status == 200) {
        const data = res.data;

        return data?.totalQROrders || 0;
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
  useEffect(() => {
    if (!socket) return;

    const onConnect = () => {
      if (user?.tenant_id) {
        socket.emit("authenticate", user.tenant_id);
      }
    };

    if (user?.tenant_id) {
      socket.emit("authenticate", user.tenant_id);
    }

    const handleQROrder = async (payload) => {
      try {
        console.log("POS received new QR order:", payload);
        unlockAudio();
        const sourceLabel = payload?.source || (payload?.deliveryType === 'room' ? 'Room Scanner' : (payload?.tableId ? `Table ${payload.tableId}` : 'Table Scanner'));
        playQROrderSound({
          source: sourceLabel,
          deliveryType: payload?.deliveryType,
          customerName: payload?.customerName,
          tableId: payload?.tableId,
        });

        const totalQROrders = await _getQROrdersCount();

        setState((prevState) => ({
          ...prevState,
          qrOrdersCount: totalQROrders || 0
        }));
      } catch (error) {
        console.log(error);
      }
    };

    const handleOrderUpdate = async (payload) => {
      try {
        const totalQROrders = await _getQROrdersCount();
        setState((prevState) => ({
          ...prevState,
          qrOrdersCount: totalQROrders || 0
        }));

      } catch (e) {
        console.error('[POSPage] Order update count error:', e);
      }
    };

    socket.on('connect', onConnect);
    socket.on('new_qrorder', handleQROrder);
    socket.on('new_order_notification', handleQROrder);
    socket.on('new_order', handleOrderUpdate);
    socket.on('order_update', handleOrderUpdate);

    return () => {
      socket.off('connect', onConnect);
      socket.off('new_qrorder', handleQROrder);
      socket.off('new_order_notification', handleQROrder);
      socket.off('new_order', handleOrderUpdate);
      socket.off('order_update', handleOrderUpdate);
    };
  }, [socket, isSocketConnected, user?.tenant_id]);

  if (isLoading) {
    return <Page className='px-4 py-3 flex flex-col min-h-0'>
      <div className='mt-4 h-[calc(100vh-136px)] flex gap-4 skeleton'>
        <div className='border border-restro-border-green-light rounded-2xl h-full w-[70%] overflow-y-auto'></div>
        <div className='border border-restro-border-green-light rounded-2xl h-full w-[30%] relative flex flex-col'></div>
      </div>
    </Page>
  }


  // cart
  function canPrepareMenuItem(menuItem, quantity = 1, selectedVariantId = null, selectedAddonIds = []) {
    const policy = state?.storeSettings?.stock_selling_policy || state?.storeSettings?.stockSellingPolicy || 'allow_negative';
    if (policy === 'allow_negative') {
      return { canPrepare: true };
    }

    if (!menuItem?.recipeItems || menuItem.recipeItems.length === 0) {
      return { canPrepare: true };
    }

    const usageMap = {};

    menuItem.recipeItems.forEach((recipe) => {
      const appliesToBase = recipe.variant_id === 0 && recipe.addon_id === 0;
      const appliesToVariant = recipe.variant_id > 0 && recipe.variant_id == selectedVariantId;
      const appliesToAddon = recipe.addon_id > 0 && selectedAddonIds.map(String).includes(recipe.addon_id.toString());

      if (appliesToBase || appliesToVariant || appliesToAddon) {
        const invId = recipe.inventory_item_id;
        const requiredQty = parseFloat(String(String(recipe.recipe_quantity).replace(/,/g, "")).replace(/,/g, "")) * quantity;

        if (!usageMap[invId]) {
          usageMap[invId] = {
            ingredient_title: recipe.ingredient_title,
            total_required: 0,
            current_quantity: parseFloat(String(String(recipe.current_quantity || 0).replace(/,/g, "")).replace(/,/g, "")),
          };
        }

        usageMap[invId].total_required += requiredQty;
      }
    });

    for (const invId in usageMap) {
      const { ingredient_title, total_required, current_quantity } = usageMap[invId];
      if (current_quantity < total_required) {
        console.warn(
          `Cannot prepare '${menuItem.title}' - Ingredient '${ingredient_title}' is insufficient`
        );
        return {
          canPrepare: false,
          reason: `Cannot sell '${menuItem.title}' - Ingredient '${ingredient_title}' is out of stock (${current_quantity} available, need ${total_required})`
        };
      }
    }

    return { canPrepare: true };
  }

  function addItemToCart(item) {
    const modifiedItem = {
      ...item,
      quantity: 1,
      notes: null
    }

    const check = canPrepareMenuItem(item, 1, item.variant_id, item.addons_ids || []);
    if (!check.canPrepare) {
      toast.error(check.reason || t('inventory.insufficient_stock_message_pos'));
      return;
    }

    if (!cartItems) {
      setState({
        ...state,
        cartItems: [modifiedItem]
      })
      return;
    }
    setState({
      ...state,
      cartItems: [...cartItems, modifiedItem]
    })
    playTapSound();
  }

  function removeItemFromCart(index) {
    setState({
      ...state,
      cartItems: cartItems.filter((c, i) => i !== index)
    })
    playTapSound();
  }

  function addCartItemQuantity(index, currentQuantity) {
    const newQuantity = currentQuantity + 1;
    const newCartItems = cartItems;

    const check = canPrepareMenuItem(newCartItems[index], newQuantity, newCartItems[index].variant_id, newCartItems[index].addons_ids || []);
    if (!check.canPrepare) {
      toast.error(check.reason || t('inventory.insufficient_stock_message_pos'));
      return;
    }

    newCartItems[index].quantity = newQuantity;

    setState({
      ...state,
      cartItems: [...newCartItems]
    });
    playTapSound();
  }
  function minusCartItemQuantity(index, currentQuantity) {
    const newQuantity = currentQuantity - 1;
    let newCartItems = cartItems;

    newCartItems[index].quantity = newQuantity;

    if (newQuantity == 0) {
      newCartItems = cartItems.filter((v, i) => i != index);
    }

    setState({
      ...state,
      cartItems: [...newCartItems]
    });
    playTapSound();
  }
  // cart

  // order notes
  const btnOpenNotesModal = (index, notes) => {
    dialogNotesIndexRef.current.value = index;
    dialogNotesTextRef.current.value = notes;
    document.getElementById('modal-notes').showModal()
  }
  const btnAddNotes = () => {
    const index = dialogNotesIndexRef.current.value;
    const notes = dialogNotesTextRef.current.value || null;

    const newCartItems = cartItems;
    newCartItems[index].notes = notes;

    setState({
      ...state,
      cartItems: newCartItems
    })
  };
  // order notes

  // category filter modal
  const btnOpenCategoryFilterModal = () => {
    categoryFilterDropdownRef.current.value = selectedCategory;
    document.getElementById('modal-categories').showModal()
  }
  const btnApplyCategoryFilter = () => {
    const selectedCategoryFromDropdown = categoryFilterDropdownRef.current.value || "";
    setState({
      ...state,
      selectedCategory: selectedCategoryFromDropdown
    })
  }
  const btnClearSelectedCategory = () => {
    setState({
      ...state,
      selectedCategory: "all"
    })
  };
  // category filter modal

  // variant, addon modal

  const resetVariantsAndAddons = () => {
    const itemVariants = document.getElementsByName("variants");
    itemVariants.forEach((item, index) => {
      item.checked = index === 0;
    });

    const itemAddons = document.getElementsByName("addons");
    itemAddons.forEach((item) => {
      item.checked = false;
    });
  };

  const btnOpenVariantAndAddonModal = (menuItemId) => {

    resetVariantsAndAddons();

    setState({
      ...state,
      selectedItemId: menuItemId
    })
    document.getElementById('modal-variants-addons').showModal()
  }
  const btnAddMenuItemToCartWithVariantsAndAddon = () => {
    let price = 0;
    let selectedVariantId = null;
    const selectedAddonsId = [];

    const itemVariants = document.getElementsByName("variants");
    itemVariants.forEach((item) => {
      if (item.checked) {
        selectedVariantId = item.value;
        return;
      }
    })

    const itemAddons = document.getElementsByName("addons");
    itemAddons.forEach((item) => {
      if (item.checked) {
        selectedAddonsId.push(item.value);
      }
    })

    // get selected menu item
    const selectedItem = menuItems.find((item) => item.id == selectedItemId);

    const addons = selectedItem?.addons || [];
    const variants = selectedItem?.variants || [];

    let selectedVariant = null;
    if (selectedVariantId) {
      selectedVariant = variants.find((v) => v.id == selectedVariantId);
      price = parseFloat(String(String(selectedVariant.price).replace(/,/g, "")).replace(/,/g, ""));
    } else {
      price = parseFloat(String(String(selectedVariant?.price ?? selectedItem.price).replace(/,/g, "")).replace(/,/g, ""))
    }

    let selectedAddons = [];
    if (selectedAddonsId.length > 0) {
      selectedAddons = selectedAddonsId.map((addonId) => addons.find((addon) => addon.id == addonId))
      selectedAddons.forEach((addon) => {
        const addonPrice = parseFloat(String(String(addon.price).replace(/,/g, "")).replace(/,/g, ""));
        price = price + addonPrice
      });
    }

    const check = canPrepareMenuItem(selectedItem, 1/**quantity */, selectedVariantId, selectedAddonsId);

    if (!check.canPrepare) {
      toast.error(check.reason || t('inventory.insufficient_stock_message_pos'));
      return;
    }

    const itemCart = { ...selectedItem, price: price, variant_id: selectedVariantId, variant: selectedVariant, addons_ids: selectedAddonsId, addons: selectedAddons }
    addItemToCart(itemCart)
  };
  // variant, addon modal

  // drafts
  const btnOpenSaveDraftModal = () => {
    if (cartItems.length == 0) {
      toast.error(t('pos.empty_cart'));
      return;
    }
    document.getElementById('modal-save-draft').showModal()
  }
  const btnAddtoDrafts = () => {
    const drafts = getDrafts();

    const nameRef = draftTitleRef.current.value || "";
    const date = new Date().toLocaleString();

    const draftItem = {
      nameRef: nameRef,
      date,
      cart: cartItems
    };

    drafts.push(draftItem);

    setDrafts(drafts);
    setState({
      ...state,
      cartItems: []
    })
  };

  const btnInitNewOrder = () => {
    setState({
      ...state,
      cartItems: [],
      customer: null,
      customerType: "WALKIN",
      selectedQrOrderItem: null,
    })
    playTapSound();
  }

  const btnOpenDraftsModal = () => {
    const drafts = getDrafts();
    setState({
      ...state,
      drafts: [...drafts]
    });
    document.getElementById("modal-drafts").showModal();
  }

  const btnDeleteDraftItem = index => {
    const drafts = getDrafts();
    const newDrafts = drafts.filter((v, i) => i != index);

    setDrafts(newDrafts);

    setState({
      ...state,
      drafts: [...newDrafts]
    });
  };

  const btnClearDrafts = () => {
    setDrafts([]);
    setState({
      ...state,
      drafts: []
    });
  };
  const btnSelectDraftItemToCart = draftItem => {
    const { nameRef, date, cart } = draftItem;

    setState({
      ...state,
      cartItems: [...cart]
    });

    document.getElementById("modal-drafts").close();
  };
  // drafts

  // QR Menu Orders
  const btnShowQROrdersModal = async () => {
    try {
      const res = await getQROrders();
      if (res.status == 200) {
        const data = res.data;
        setState({
          ...state,
          qrOrders: [...data]
        })
        document.getElementById("modal-qrorders").showModal();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const btnClearQROrders = async () => {
    const isConfirm = window.confirm(t('pos.delete_confirm'));
    if (!isConfirm) {
      return;
    }
    try {
      toast.loading(t('pos.please_wait'));
      const res = await cancelAllQROrders();
      if (res.status == 200) {
        toast.dismiss();
        toast.success(res.data.message);
        setState((prevState) => ({
          ...prevState, qrOrders: [], qrOrdersCount: 0,
        }))
        playTapSound();
      }
    } catch (error) {
      const message = error?.response?.data?.message || t('pos.getting_issues');
      console.log(error);
      toast.dismiss();
      toast.error(message);
    }
  }
  const btnCancelQROrder = async (orderId) => {
    const isConfirm = window.confirm(t('pos.delete_confirm'));
    if (!isConfirm) {
      return;
    }
    try {
      toast.loading(t('pos.please_wait'));
      const res = await cancelQROrder(orderId);
      if (res.status == 200) {
        toast.dismiss();
        toast.success(res.data.message);

        const newQROrders = state.qrOrders.filter((item) => item.id != orderId);
        const newQROrderItem = state.qrOrdersCount - 1;

        setState((prevState) => ({
          ...prevState, qrOrders: [...newQROrders], qrOrdersCount: newQROrderItem,
        }))
      }
    } catch (error) {
      const message = error?.response?.data?.message || t('pos.getting_issues');
      console.log(error);
      toast.dismiss();
      toast.error(message);
    }
  }
  const btnSelectQROrder = (qrOrder) => {
    console.log(qrOrder);

    if (qrOrder.table_id) {
      tableRef.current.value = qrOrder.table_id;
    }

    // const itemCart = {...selectedItem, price: price, variant_id: selectedVariantId, variant: selectedVariant, addons_ids: selectedAddonsId, addons: selectedAddons}

    const modifiedCart = qrOrder.items.map((item) => {
      const id = item.item_id;

      let selectedVariant = {
        id: item.variant_id,
        item_id: id,
        price: item.variant_price,
        title: item.variant_title,
      }

      return {
        ...item,
        id: id,
        title: item.item_title,
        addons_ids: item?.addons?.map((i) => i.id),
        variant: selectedVariant || null,
        variant_id: item.variant_id || null,
      }
    })

    setState({
      ...state,
      cartItems: modifiedCart,
      selectedQrOrderItem: qrOrder.id,
      customerType: qrOrder.customer_type,
      customer: { phone: qrOrder.customer_id, name: qrOrder.customer_name },
      deliveryType: qrOrder.delivery_type || "dine_in",
      source: qrOrder.source || null,
      tableId: qrOrder.table_id || null,
    })
    playTapSound();

    document.getElementById('modal-qrorders').close();
  };
  // QR MEnu Orders

  // search customer modal
  const btnOpenSearchCustomerModal = () => {
    document.getElementById("modal-search-customer").showModal();
  };
  const btnClearSearchCustomer = () => {
    setState({
      ...state,
      customerType: "WALKIN",
      customer: null,
      customerLoyalty: null,
      loyaltyRedemptionAmount: 0,
      loyaltyPointsRedeemed: 0,
      loyaltyItemsRedeemed: 0
    })
  }
  const btnSearchCustomer = async () => {
    const phone = searchCustomerRef.current.value;

    if (!phone) {
      toast.error(t('pos.please_provide_phone'));
      return;
    }

    try {
      toast.loading(t('pos.please_wait'));
      const resp = await searchCustomer(phone);
      toast.dismiss();
      if (resp.status == 200) {
        setState({
          ...state,
          customer: resp.data,
          customerType: "CUSTOMER"
        })
        document.getElementById("modal-search-customer").close()
      }

    } catch (error) {
      console.log(error);
      const message = error.response.data.message || t('pos.error_getting_details');
      toast.dismiss();
      toast.error(message);
    }
  }
  // search customer modal


  // send to kitchen modal
  function calculateOrderSummary() {
    let rawItemsTotal = 0;
    let payableTotal = 0;
    let serviceChargeTotal = 0;
    let taxTotal = 0;

    // 1. Get raw base amounts
    cartItems.forEach((item) => {
      if (item.is_complementary) return;
      const taxRate = Number(String(String(item.tax_rate).replace(/,/g, "")).replace(/,/g, "")) || 0;
      const itemPrice = Number(String(String(item.price).replace(/,/g, "")).replace(/,/g, "")) * Number(String(String(item.quantity).replace(/,/g, "")).replace(/,/g, ""));

      let itemBase = itemPrice;
      if (item.tax_type === "inclusive") {
        itemBase = itemPrice / (1 + taxRate / 100);
      }
      rawItemsTotal += itemBase;
    });

    // 2. Calculate Discount on the Base Amount
    let discountAmount = 0;
    const discountValue = Number(String(String(state.discount || 0).replace(/,/g, "")).replace(/,/g, ""));
    if (state.discountType === "percent") {
      discountAmount = (rawItemsTotal * discountValue) / 100;
    } else {
      discountAmount = discountValue;
    }

    // Safety check for over-discounting
    if (discountAmount > rawItemsTotal) discountAmount = rawItemsTotal;

    const discountRatio = rawItemsTotal > 0 ? discountAmount / rawItemsTotal : 0;

    // 3. Calculate Service Charge on the Base Amount
    if (state.serviceCharge) {
      serviceChargeTotal = (rawItemsTotal * Number(String(String(state.serviceCharge).replace(/,/g, "")).replace(/,/g, ""))) / 100;
    }
    const scRatio = rawItemsTotal > 0 ? serviceChargeTotal / rawItemsTotal : 0;

    // 4. Calculate Tax and Finals Item by Item
    let itemsTotal = 0; // This will be the actual Subtotal (Base)
    cartItems.forEach((item) => {
      if (item.is_complementary) return;
      const taxRate = Number(String(String(item.tax_rate).replace(/,/g, "")).replace(/,/g, "")) || 0;
      const itemPrice = Number(String(String(item.price).replace(/,/g, "")).replace(/,/g, "")) * Number(String(String(item.quantity).replace(/,/g, "")).replace(/,/g, ""));

      let itemBase = itemPrice;
      if (item.tax_type === "inclusive") {
        itemBase = itemPrice / (1 + taxRate / 100);
      }

      // Proportional discount and service charge for this item
      const itemDiscount = itemBase * discountRatio;
      const itemSC = itemBase * scRatio;

      // Taxable amount is Base - Discount + SC
      const itemTaxable = itemBase - itemDiscount + itemSC;

      // Calculate Tax
      let itemTax = 0;
      if (item.tax_type === "exclusive" || item.tax_type === "inclusive") {
        itemTax = (itemTaxable * taxRate) / 100;
      }

      itemsTotal += itemBase;
      taxTotal += itemTax;
      payableTotal += (itemTaxable + itemTax);
    });

    payableTotal -= state.loyaltyRedemptionAmount || 0;

    return {
      itemsTotal, taxTotal, serviceChargeTotal, payableTotal, discountAmount
    }
  };
  const btnShowPayAndSendToKitchenModal = () => {
    // calculate the item - total, tax, incl. tax, excl. tax, tax total, payable total

    if (cartItems?.length == 0) {
      toast.error(t('pos.empty_cart'));
      return;
    }

    const { itemsTotal, taxTotal, serviceChargeTotal, payableTotal, discountAmount } = calculateOrderSummary();

    setState({
      ...state,
      itemsTotal,
      taxTotal,
      serviceChargeTotal,
      payableTotal,
      discount: discountAmount,
      roundOff: 0,
      targetTotal: undefined,
      paidAmount: undefined
    });
    document.getElementById('modal-pay-and-send-kitchen-summary').showModal();
  }

  const handleLoyaltyRedemption = (e) => {
    const value = parseFloat(String(String(e.target.value).replace(/,/g, "")).replace(/,/g, "")) || 0;
    const settings = state.loyaltySettings;
    const loyalty = state.customerLoyalty;

    if (!settings || !loyalty) return;

    if (settings.type === 'points') {
      const maxRedeemablePoints = loyalty.points_balance;
      const pointsToRedeem = Math.min(value, maxRedeemablePoints);
      const amountToRedeem = (pointsToRedeem * settings.point_value) / 100;

      setState(prev => ({
        ...prev,
        loyaltyPointsRedeemed: pointsToRedeem,
        loyaltyRedemptionAmount: amountToRedeem
      }));
    } else if (settings.type === 'item') {
      const itemsToRedeem = Math.min(value, Math.floor(loyalty.items_count / settings.threshold_count));
      setState(prev => ({
        ...prev,
        loyaltyItemsRedeemed: itemsToRedeem * settings.threshold_count,
      }));
    }
  };

  const addPaymentRow = () => {
    const discountVal = state.discountType === "percent"
      ? (state.payableTotal * state.discount / 100)
      : (state.discount || 0);
    const beforeRound = Math.max(0, state.payableTotal - discountVal - (state.loyaltyRedemptionAmount || 0));
    const totalToPay = state.paidAmount === undefined ? Math.max(0, beforeRound + Number(state.roundOff || 0)) : state.paidAmount;
    const currentPaid = state.multiPayments.reduce((acc, p) => acc + parseFloat(String(String(p.amount || 0).replace(/,/g, "")).replace(/,/g, "")), 0);
    const remaining = totalToPay - currentPaid;

    const firstType = paymentTypes[0];
    setState({
      ...state,
      multiPayments: [
        ...state.multiPayments,
        { payment_type_id: firstType?.id, amount: Math.max(0, remaining), title: firstType?.title }
      ]
    });
  };

  const removePaymentRow = (index) => {
    const newPayments = [...state.multiPayments];
    newPayments.splice(index, 1);
    setState({ ...state, multiPayments: newPayments });
  };

  const handleMultiPaymentChange = (index, field, value) => {
    const newPayments = [...state.multiPayments];
    if (field === 'payment_type_id') {
      const type = (paymentTypes?.find ? paymentTypes : []).find(t => t.id == value);
      newPayments[index].payment_type_id = value;
      newPayments[index].title = type?.title;
    } else {
      newPayments[index][field] = value;
    }
    setState({ ...state, multiPayments: newPayments });
  };

  const btnPayAndSendToKitchen = async () => {
    if (state.multiPayments.length === 0 && !state.selectedPaymentType) {
      return toast.error(t('orders.select_payment_method'));
    }
    const discountVal = state.discountType === "percent"
      ? (state.itemsTotal * Number(state.discount || 0) / 100)
      : (Number(state.discount) || 0);
    const taxableAmount = Math.max(0, state.itemsTotal - discountVal + (state.serviceChargeTotal || 0));
    const effectiveTaxRate = state.itemsTotal > 0 ? (state.taxTotal / state.itemsTotal) : 0;
    const calculatedTax = Number((taxableAmount * effectiveTaxRate).toFixed(2));
    const beforeRound = Math.max(0, taxableAmount + calculatedTax - (state.loyaltyRedemptionAmount || 0));
    const roundOffVal = Number(state.roundOff || 0);
    const total = Math.max(0, Number((beforeRound + roundOffVal).toFixed(2)));
    const paid = state.paidAmount === undefined ? total : state.paidAmount;
    const isDue = paid < total;

    if (isDue && !state.customer) {
      return toast.error("Customer selection is compulsory for Due payments.");
    }

    if (state.multiPayments.length > 0) {
      const sum = state.multiPayments.reduce((acc, p) => acc + parseFloat(String(String(p.amount || 0).replace(/,/g, "")).replace(/,/g, "")), 0);
      if (Math.abs(sum - paid) > 0.01) {
        return toast.error(`Total of split payments (${sum.toFixed(2)}) must equal the paid amount (${paid.toFixed(2)})`);
      }
    }

    try {
      const deliveryType = diningOptionRef.current.value;
      const tableId = tableRef.current?.value || null;
      const customerType = state.customerType;
      const customer = state.customer;
      const source = deliveryType === 'room' ? (roomRef.current?.value || null) : null;

      toast.loading(t('pos.please_wait'));
      const res = await createOrderAndInvoice(cartItems, deliveryType, customerType, customer?.id || null, tableId, state.itemsTotal, calculatedTax, state.serviceChargeTotal, total, state.selectedQrOrderItem, state.selectedPaymentType, discountVal, paid, state.loyaltyRedemptionAmount, state.loyaltyPointsRedeemed, state.loyaltyItemsRedeemed, state.multiPayments, source, roundOffVal);
      toast.dismiss();
      if (res.status == 200) {
        const data = res.data;
        toast.success(res.data.message);
        document.getElementById("modal-pay-and-send-kitchen-summary").close();

        const page_format = printSettings?.page_format || null;
        const is_enable_print = printSettings?.is_enable_print || 0;

        const paymentType = (paymentTypes?.find ? paymentTypes : []).find((v) => v.id == state.selectedPaymentType);
        let paymentMethodText;
        if (paymentType) {
          paymentMethodText = paymentType.title;
        }

        const posRoomSource = deliveryType === 'room' ? (roomRef.current?.value || null) : null;
        let posTableTitle = tableId ? `Table ${tableId}` : '';
        if (deliveryType === 'room') {
          posTableTitle = posRoomSource ? (posRoomSource.toLowerCase().startsWith('room') ? posRoomSource : `Room ${posRoomSource}`) : 'Room Order';
        } else if (storeTables) {
          const t = storeTables.find(tb => tb.id == tableId);
          if (t) posTableTitle = t.table_title || t.table_no;
        }

        setDetailsForReceiptPrint({
          cartItems, deliveryType, customerType, customer, tableId, currency, storeSettings, printSettings,
          table_title: posTableTitle,
          source: posRoomSource,
          room_name: posRoomSource,
          itemsTotal: state.itemsTotal,
          taxTotal: calculatedTax,
          taxableAmount: taxableAmount,
          serviceChargeTotal: state.serviceChargeTotal,
          storedDiscount: discountVal,
          roundOff: roundOffVal,
          payableTotal: total,
          paidAmount: paid,
          dueAmount: Math.max(0, total - paid),
          tokenNo: data.tokenNo,
          orderId: data.orderId,
          invoiceId: data.invoiceId,
          invoice_id: data.invoiceId,
          billNo: data.invoiceId,
          invoiceNo: data.invoiceId,
          created_at: new Date(),
          date: new Date(),
          paymentMethod: paymentMethodText,
          paymentTypeDetails: paymentType,
          cashTendered: state.cashTendered,
          changeAmount: Math.max(0, (state.cashTendered || 0) - paid),
        });

        lastPlacedOrderIdRef.current = data.orderId;
        if (typeof window !== 'undefined') {
          window.__lastLocalPlacedOrderId = data.orderId;
          window.__printedItemFingerprints = window.__printedItemFingerprints || new Set();
          (cartItems || []).forEach(ci => {
            const varId = ci.variant_id || ci.variantId || 0;
            const qty = ci.quantity || ci.qty || 1;
            const notes = ci.notes || '';
            window.__printedItemFingerprints.add(`ord_${data.orderId}_it_${ci.id}_v_${varId}_q_${qty}_n_${notes}`);
          });
        }
        sendNewOrderEvent(data.tokenNo, data.orderId);

        let newQROrderItemCount = state.qrOrdersCount;
        let newQROrders = [];
        if (state.selectedQrOrderItem) {
          newQROrderItemCount -= 1;
          newQROrders = state?.qrOrders?.filter((item) => item.id != state.selectedQrOrderItem);
        }

        setState((prev) => ({
          ...prev,
          cartItems: [],
          tokenNo: data.tokenNo,
          orderId: data.orderId,
          selectedQrOrderItem: null,
          qrOrders: newQROrders,
          qrOrdersCount: newQROrderItemCount,
          selectedPaymentType: null,
          multiPayments: [],
          discount: 0,
          discountType: "fixed",
        }))

        _initPOS()

        // Auto-print KOT per category for the kitchen
        const shouldAutoPrintKOT = is_enable_print || localStorage.getItem('kdsAutoPrint') !== 'false';
        if (shouldAutoPrintKOT) {
          const printerGroups = groupItemsByPrinter(cartItems, categories);
          printKOT(printerGroups, {
            tableId,
            table_title: posTableTitle,
            deliveryType,
            source: posRoomSource,
            room_name: posRoomSource,
            tokenNo: data.tokenNo,
            orderId: data.orderId,
            customerName: customer?.name,
            page_format: page_format || localStorage.getItem('page_format') || '58',
            pageFormat: page_format || localStorage.getItem('page_format') || '58'
          });
        }

        if (is_enable_print) {
          import('../helpers/PrinterHelper').then(({ printReceipt }) => {
            import('../helpers/ReceiptHelper').then(({ getDetailsForReceiptPrint }) => {
              const details = getDetailsForReceiptPrint();
              if (details) {
                printReceipt({
                  ...details,
                  printSettings,
                  pageFormat: printSettings?.page_format || localStorage.getItem('page_format') || '58'
                });
              }
            });
          });
          return;
        }

        // show print token dialog
        document.getElementById("modal-print-token").showModal();
      }
    } catch (error) {
      const message = error?.response?.data?.message || t('pos.something_went_wrong');
      console.error(error);

      toast.dismiss();
      toast.error(message);
    }
  };

  const btnShowSendToKitchenModal = () => {
    // calculate the item - total, tax, incl. tax, excl. tax, tax total, payable total

    if (cartItems?.length == 0) {
      toast.error(t('pos.empty_cart'));
      return;
    }

    const { itemsTotal, taxTotal, serviceChargeTotal, payableTotal, discountAmount } = calculateOrderSummary();

    setState({
      ...state,
      itemsTotal,
      taxTotal,
      serviceChargeTotal,
      payableTotal,
      discount: discountAmount
    });
    document.getElementById('modal-send-kitchen-summary').showModal();
  }

  const btnSendToKitchen = async () => {
    try {
      const deliveryType = diningOptionRef.current.value;
      const tableId = tableRef.current?.value || null;
      const customerType = state.customerType;
      const customer = state.customer;
      const source = deliveryType === 'room' ? (roomRef.current?.value || null) : null;

      toast.loading(t('pos.please_wait'));

      // EDIT MODE: update the existing order
      if (state.editOrderId) {
        const res = await updateOrder(state.editOrderId, cartItems, deliveryType, customerType, customer, tableId, source);
        toast.dismiss();
        if (res.status === 200) {
          toast.success(`Order #${state.editOrderId} updated successfully!`);
          document.getElementById("modal-send-kitchen-summary").close();
          setState(prev => ({ ...prev, cartItems: [], editOrderId: null }));
          navigate('/dashboard/orders', { replace: true });
        }
        return;
      }

      // NORMAL MODE: create new order
      const res = await createOrder(cartItems, deliveryType, customerType, customer, tableId, state.selectedQrOrderItem, source);
      toast.dismiss();
      if (res.status == 200) {
        const data = res.data;
        toast.success(res.data.message);
        document.getElementById("modal-send-kitchen-summary").close();

        const page_format = printSettings?.page_format || null;
        const is_enable_print = printSettings?.is_enable_print || 0;

        const posRoomSource = deliveryType === 'room' ? (roomRef.current?.value || null) : null;
        let posTableTitle = tableId ? `Table ${tableId}` : '';
        if (deliveryType === 'room') {
          posTableTitle = posRoomSource ? (posRoomSource.toLowerCase().startsWith('room') ? posRoomSource : `Room ${posRoomSource}`) : 'Room Order';
        } else if (storeTables) {
          const t = storeTables.find(tb => tb.id == tableId);
          if (t) posTableTitle = t.table_title || t.table_no;
        }

        setDetailsForReceiptPrint({
          cartItems, deliveryType, customerType, customer, tableId, currency, storeSettings, printSettings,
          table_title: posTableTitle,
          source: posRoomSource,
          room_name: posRoomSource,
          itemsTotal: state.itemsTotal,
          taxTotal: state.taxTotal,
          serviceChargeTotal: state.serviceChargeTotal,
          payableTotal: state.payableTotal,
          tokenNo: data.tokenNo,
          orderId: data.orderId
        });

        lastPlacedOrderIdRef.current = data.orderId;
        if (typeof window !== 'undefined') {
          window.__lastLocalPlacedOrderId = data.orderId;
          window.__printedItemFingerprints = window.__printedItemFingerprints || new Set();
          (cartItems || []).forEach(ci => {
            const varId = ci.variant_id || ci.variantId || 0;
            const qty = ci.quantity || ci.qty || 1;
            const notes = ci.notes || '';
            window.__printedItemFingerprints.add(`ord_${data.orderId}_it_${ci.id}_v_${varId}_q_${qty}_n_${notes}`);
          });
        }
        sendNewOrderEvent(data.tokenNo, data.orderId);

        let newQROrderItemCount = state.qrOrdersCount;
        let newQROrders = [];
        if (state.selectedQrOrderItem) {
          newQROrderItemCount -= 1;
          newQROrders = state?.qrOrders?.filter((item) => item.id != state.selectedQrOrderItem);
        }

        setState((prev) => ({
          ...prev,
          cartItems: [],
          tokenNo: data.tokenNo,
          orderId: data.orderId,
          selectedQrOrderItem: null,
          qrOrders: newQROrders,
          qrOrdersCount: newQROrderItemCount
        }))

        _initPOS()

        
        const shouldAutoPrintKOT = is_enable_print || localStorage.getItem('kdsAutoPrint') !== 'false';
        if(shouldAutoPrintKOT) {
          const printerGroups = groupItemsByPrinter(cartItems, categories);
          const page_format = printSettings?.page_format || localStorage.getItem('page_format') || '58';

          printKOT(printerGroups, {
            tableId,
            table_title: posTableTitle,
            deliveryType,
            source: posRoomSource,
            room_name: posRoomSource,
            tokenNo: data.tokenNo,
            orderId: data.orderId,
            customerName: customer?.name,
            page_format: page_format,
            pageFormat: page_format
          });
        }


        // show print token dialog
        document.getElementById("modal-print-token").showModal();
      }
    } catch (error) {
      const message = error?.response?.data?.message || t('pos.something_went_wrong');
      console.error(error);

      toast.dismiss();
      toast.error(message);
    }
  };
  const btnPrintTokenOnly = () => {
    let iframe = document.getElementById('token-print-iframe');
    if (!iframe) {
      iframe = document.createElement('iframe');
      iframe.id = 'token-print-iframe';
      iframe.style.position = 'fixed';
      iframe.style.left = '-9999px';
      iframe.style.width = '300px';
      iframe.style.height = '600px';
      document.body.appendChild(iframe);
    }
    iframe.src = "/print-token";
    iframe.onload = () => {
      setTimeout(() => {
        try {
          iframe.contentWindow.focus();
          iframe.contentWindow.print();
        } catch (e) {
          console.error(e);
        }
      }, 500);
    };
    return;
  };
  // send to kitchen modal


  const setCustomer = (customer) => {

    if (customer) {
      setState({
        ...state,
        customer: { phone: customer.value, name: customer.label },
        customerType: "CUSTOMER"
      })
      document.getElementById("modal-search-customer").close()
    } else {
      btnClearSearchCustomer();
    }
  }

  const searchCustomersAsync = async (inputValue) => {
    try {
      if (inputValue) {
        const resp = await searchCustomer(inputValue);
        if (resp.status == 200) {
          return resp.data.map((data) => ({ label: `${data.name} - (${data.phone})`, value: data.phone }));
        }
      }
    } catch (error) {
      console.log(error);
    }
  }
  // search customer modal


  return (
    <Page className='px-4 py-3 flex flex-col min-h-0'>
      <div className="flex md:items-center justify-between flex-col md:flex-row gap-2">
        <h3>{t('pos.title')}</h3>
        <div className='flex flex-wrap items-center gap-4'>
          <button onClick={btnInitNewOrder} className="text-sm rounded-lg border transition active:scale-95 hover:shadow-lg px-2 py-1 flex items-center gap-1 text-restro-text bg-restro-gray border-restro-border-green hover:bg-restro-button-hover">
            <IconPlus size={18} stroke={iconStroke} /> {t('pos.new_order')}
          </button>

          {/* QR Menu Orders */}
          <button
            onClick={btnShowQROrdersModal}
            className="relative text-sm rounded-lg border transition active:scale-95 hover:shadow-lg px-2 py-1 flex items-center gap-1 text-restro-text bg-restro-gray border-restro-border-green hover:bg-restro-button-hover">
            <IconQrcode size={18} stroke={iconStroke} /> {t('pos.qr_menu_orders')}

            {state.qrOrdersCount > 0 && <div className='absolute -top-2 -right-2 w-4 h-4 rounded-full bg-red-500 text-white text-xs flex items-center justify-center'> {state.qrOrdersCount}
            </div>}
          </button>
          {/* QR Menu Orders */}

          <button onClick={btnOpenDraftsModal} className="relative text-sm rounded-lg border transition active:scale-95 hover:shadow-lg text-gray-500 px-2 py-1 flex items-center gap-1 text-restro-text bg-restro-gray border-restro-border-green hover:bg-restro-button-hover">
            <IconNotes size={18} stroke={iconStroke} /> {t('pos.drafts_list')}
          </button>

          <Link to="/dashboard/orders" className="relative text-sm rounded-lg border transition active:scale-95 hover:shadow-lg text-gray-500 px-2 py-1 flex items-center gap-1 text-restro-text bg-restro-gray border-restro-border-green hover:bg-restro-button-hover">
            <IconArmchair size={18} stroke={iconStroke} /> {t('pos.table_orders')}
          </Link>
        </div>
      </div>

      <div className='mt-4 md:h-[calc(100vh-136px)] flex flex-col-reverse md:flex-row gap-4'>

        {/* pos items */}
        <div className="h-full md:w-[70%] overflow-y-auto scrollbar-none border rounded-2xl border-restro-border-green">
          {/* categories, search, toggle View*/}
          <div className="bg-background flex gap-2 justify-between sticky top-0 w-full z-10 px-4 py-3 rounded-t-2xl">
            <div className="flex overflow-x-auto space-x-2 text-sm custom-scroll-wrapper scrollbar scrollbar-none custom-scroll-div-horizon-smooth">
              <div className="flex overflow-x-auto space-x-2 text-sm scrollbar scrollbar-none custom-scroll-div-horizon-smooth">
                <button
                  className={`min-w-28 px-4 py-2 rounded-xl ${selectedCategory === "all" ? theme === 'black' ? 'bg-restro-green-dark-mode text-white' : 'bg-restro-green text-white' : theme === 'black' ? 'bg-restro-bg-seconday-dark-mode' : 'bg-gray-100 text-gray-600'}`}
                  onClick={() => {
                    setState({
                      ...state,
                      selectedCategory: 'all'
                    })
                  }}
                >
                  {t('pos.all')}
                </button>
                {categories.filter((category) => category && category.is_enabled !== false && category.is_enabled !== 0 && category.is_enabled !== '0').map((category, index) => (
                  <button
                    key={index}
                    className={`min-w-fit px-4 py-2 rounded-xl ${String(selectedCategory) === String(category.id) ? theme === 'black' ? 'bg-restro-green-dark-mode text-white' : 'bg-restro-green text-white' : theme === 'black' ? 'bg-restro-bg-seconday-dark-mode' : 'bg-gray-100 text-gray-600'}`}
                    onClick={() => {
                      setState({
                        ...state,
                        selectedCategory: category.id
                      })
                    }}
                  >
                    {category.title}
                  </button>
                ))}
              </div>
            </div>
            <div className="flex items-center gap-2">
              <label className="flex items-center w-60 rounded-xl px-3 py-2 gap-2 bg-restro-gray border border-restro-border-green">
                <IconSearch size={18} stroke={iconStroke} />
                <input value={searchQuery} onChange={e => setState({ ...state, searchQuery: e.target.value })} type="search" placeholder={t('appbar.search_placeholder')} className='w-full bg-transparent outline-none' />
              </label>
              <button
                className={clsx(`px-3 py-2 rounded-xl`,
                  theme === "black" ? state.view === "compact" ? "text-restro-green bg-restro-bg-seconday-dark-mode hover:bg-restro-bg-hover-dark-mode" : "text-gray-300 bg-restro-bg-seconday-dark-mode hover:bg-restro-bg-hover-dark-mode" : state.view === "compact" ? "text-restro-green bg-gray-100  hover:bg-gray-200" : "text-gray-400 bg-gray-100  hover:bg-gray-200"
                )}
                onClick={() => {
                  const newView = state.view === 'detailed' ? 'compact' : 'detailed';
                  setState((prev) => ({
                    ...prev,
                    view: newView
                  }));
                  sessionStorage.setItem('view', newView);
                }}>
                <IconLayout2 size={24} stroke={2} />
              </button>
            </div>
          </div>
          {/* categories, search */}


          {/* list */}
          <div className='flex-1 h-full pt-3'>
            {state.view == 'detailed' ?
              <POSMenuItemDetailedView
                menuItems={menuItems}
                selectedCategory={selectedCategory}
                categories={categories}
                searchQuery={searchQuery}
                currency={currency}
                stockSellingPolicy={state.storeSettings?.stock_selling_policy || state.storeSettings?.stockSellingPolicy || 'allow_negative'}
                btnOpenVariantAndAddonModal={btnOpenVariantAndAddonModal}
                addItemToCart={addItemToCart}
              /> :
              <POSMenuItemCompactView
                menuItems={menuItems}
                selectedCategory={selectedCategory}
                categories={categories}
                searchQuery={searchQuery}
                currency={currency}
                stockSellingPolicy={state.storeSettings?.stock_selling_policy || state.storeSettings?.stockSellingPolicy || 'allow_negative'}
                btnOpenVariantAndAddonModal={btnOpenVariantAndAddonModal}
                addItemToCart={addItemToCart}
              />
            }
          </div>
          {/* list */}


        </div>
        {/* pos items */}

        {/* cart */}
        <div className="flex flex-col h-full md:w-[30%] relative border rounded-2xl border-restro-border-green">

          <div className="sticky w-full px-4 py-3 border-b rounded-t-2xl border-restro-border-green">
            {/* search customer */}
            <div onClick={btnOpenSearchCustomerModal} className="flex items-center gap-2">
              <input value={customerType == "WALKIN" ? t('pos.walkin_customer') : `${customer.name}`} type="text" placeholder={t('pos.search_customer')} className="flex items-center gap-1 text-sm w-full px-4 py-2 transition active:scale-95 hover:shadow-lg border rounded-lg bg-restro-gray border-restro-border-green hover:bg-restro-button-hover outline-restro-border-green" />
              <button onClick={btnOpenSearchCustomerModal} className="flex items-center justify-center w-9 h-9 transition active:scale-95 rounded-lg hover:shadow-lg bg-restro-gray border border-restro-border-green hover:bg-restro-button-hover">
                <IconSearch size={18} stroke={iconStroke} />
              </button>
            </div>
            {/* search customer */}

            {/* delivery type */}
            <select
              ref={diningOptionRef}
              value={diningOption}
              onChange={(e) => setDiningOption(e.target.value)}
              className="mt-3 text-sm w-full border rounded-lg px-4 py-2 justify-center bg-restro-gray border-restro-border-green hover:bg-restro-button-hover focus:outline-restro-border-green"
            >
              <option value="">{t('pos.select_dining_option')}</option>
              <option value="dinein">{t('pos.dinein')}</option>
              <option value="delivery">{t('pos.delivery')}</option>
              <option value="takeaway">{t('pos.takeaway')}</option>
              <option value="room">Room Service / Folio</option>
            </select>
            {/* delivery type */}

            {diningOption === "room" ? (
              <select ref={roomRef} className="mt-3 text-sm w-full border rounded-lg px-4 py-2 justify-center bg-restro-gray border-restro-border-green hover:bg-restro-button-hover focus:outline-restro-border-green">
                <option value="">Select Room</option>
                {state.rooms?.map((room, index) => {
                  const isOccupied = !!room.active_booking_id;
                  return (
                    <option
                      value={room.name}
                      key={index}
                      disabled={!isOccupied}
                      className={!isOccupied ? "text-gray-400 italic" : "font-bold text-restro-text"}
                    >
                      Room {room.name} {isOccupied ? `(Occupied - ${room.occupant || "Guest"})` : "(Available - Cannot Select)"}
                    </option>
                  );
                })}
              </select>
            ) : (
              <select ref={tableRef} className="mt-3 text-sm w-full border rounded-lg px-4 py-2 justify-center bg-restro-gray border-restro-border-green hover:bg-restro-button-hover focus:outline-restro-border-green">
                <option value="">{t('pos.select_table')}</option>
                {
                  storeTables.map((table, index) => {
                    return <option value={table.id} key={index}>{table.table_title} ({table.seating_capacity} {t('pos.person')}) - {table.floor}</option>
                  })
                }
              </select>
            )}
            {/* table/room selection */}
          </div>


          {/* items */}
          <div className='flex-1 flex flex-col gap-4 overflow-y-auto px-4 pb-36'>
            <div className="h-1"></div>
            {cartItems?.map((cartItem, i) => {
              const { quantity, notes, title, price, variant, addons } = cartItem;
              const itemTotal = price * quantity;
              return <div key={i} className="text-sm rounded-lg p-2 relative border border-restro-border-green">
                <p>#{i + 1} {title} x {quantity} {cartItem.is_complementary && <span className="badge badge-success badge-sm">{t('pos.complementary')}</span>}</p>
                <p className='mt-1'>{currency}{Number(String(String(price || 0).replace(/,/g, "")).replace(/,/g, "")).toFixed(2)} <span className='text-xs'>x {quantity}</span> <span className='font-bold'>= {currency}{(cartItem.is_complementary ? 0 : itemTotal).toFixed(2)}</span></p>
                {notes && <p className="mt-1 text-xs text-gray-400">
                  {t('pos.notes')}: {notes}
                </p>
                }

                {variant && <p className="mt-1 text-xs text-gray-400">{t('pos.variant')}: {variant.title}</p>}
                {(addons && addons?.length > 0) && <p className="mt-1 text-xs text-gray-400">{t('pos.addons')}: {addons?.map((addon) => (`${addon.title}`))?.join(", ")}</p>}

                <div className="flex items-center justify-between gap-2 w-full mt-4">
                  <div className='flex items-center gap-2'>
                    <button onClick={() => {
                      minusCartItemQuantity(i, quantity);
                    }} className="btn btn-square btn-xs rounded-md bg-restro-gray hover:bg-restro-button-hover">
                      <IconMinus stroke={iconStroke} size={18} />
                    </button>
                    <div className='w-8 h-8 flex items-center justify-center font-semibold'>
                      {quantity}
                    </div>
                    <button onClick={() => {
                      addCartItemQuantity(i, quantity);
                    }} className="btn btn-square btn-xs rounded-md bg-restro-gray hover:bg-restro-button-hover">
                      <IconPlus stroke={iconStroke} size={18} />
                    </button>
                  </div>
                  <div className='flex items-center gap-1'>
                    <button onClick={() => { btnOpenNotesModal(i, notes) }} className="flex items-center text-sm transition active:scale-95 hover:shadow-lg  px-2 py-1 gap-1 rounded-lg border border-restro-border-green bg-restro-gray hover:bg-restro-button-hover">
                      <div><IconNote size={18} stroke={iconStroke} /></div> <p>{t('pos.add_notes')}</p>
                    </button>
                    <button onClick={() => {
                      const newCartItems = [...cartItems];
                      newCartItems[i].is_complementary = !newCartItems[i].is_complementary;
                      setState({ ...state, cartItems: newCartItems });
                    }} className={`flex items-center text-sm transition active:scale-95 hover:shadow-lg px-2 py-1 gap-1 rounded-lg border border-restro-border-green ${cartItem.is_complementary ? 'bg-restro-green text-white' : 'bg-restro-gray hover:bg-restro-button-hover'}`}>
                      <IconGift size={18} stroke={iconStroke} />
                    </button>
                  </div>
                </div>

                {/* action btn delete */}
                <button onClick={() => {
                  removeItemFromCart(i);
                }} className="flex items-center justify-center absolute right-2 top-2 text-restro-red rounded-full w-6 h-6 transition bg-restro-gray hover:bg-restro-button-hover ">
                  <IconTrash stroke={iconStroke} size={14} />
                </button>
                {/* action btn delete */}
              </div>
            })}
          </div>
          {/* items */}



          {/* actions */}
          <div className="absolute w-full bottom-0 pb-4 rounded-b-2xl px-4 backdrop-blur border border-t border-b-0 border-l-0 border-r-0 border-restro-border-green">
            <div className="flex items-center flex-col lg:flex-row gap-2 mt-4">
              <button onClick={btnOpenSaveDraftModal} className="flex items-center flex-1 lg:flex-none text-sm transition active:scale-95 hover:shadow-lg px-2 py-2 gap-1 text-restro-text border rounded-lg border-restro-border-green bg-restro-gray hover:bg-restro-button-hover">
                <IconDeviceFloppy size={18} stroke={iconStroke} /> {t('pos.draft')}
              </button>

              <button onClick={btnShowSendToKitchenModal} className="flex-1 flex justify-center items-center text-sm transition active:scale-95 hover:shadow-lg px-2 py-2  gap-1 text-restro-text border rounded-lg border-restro-border-green bg-restro-gray hover:bg-restro-button-hover">
                <div><IconChefHat size={18} stroke={iconStroke} /></div> <p>{t('pos.send_to_kitchen')}</p>
              </button>
            </div>
            <div className="mt-2">
              <button onClick={btnShowPayAndSendToKitchenModal} className="flex items-center justify-center text-sm transition active:scale-95 hover:shadow-lg px-2 py-2 w-full gap-1 text-white border rounded-lg border-restro-border-green bg-restro-green hover:bg-restro-green-button-hover">
                <div><IconCash size={18} stroke={iconStroke} /></div> <p>{t('pos.create_receipt_pay')}</p>
              </button>
            </div>
          </div>
          {/* actions */}

        </div>
        {/* cart */}

      </div>


      {/* dialog: notes */}
      <dialog id="modal-notes" className="modal modal-bottom sm:modal-middle">
        <div className="modal-box border border-restro-border-green dark:rounded-2xl">
          <div className='flex justify-between items-center'>
            <h3 className="font-bold text-lg">{t('pos.add_notes')}</h3>
            <button className="text-restro-red p-2 rounded-full bg-restro-gray hover:bg-restro-button-hover" onClick={() => document.getElementById('modal-notes').close()}><IconX size={18} stroke={iconStroke} /></button>
          </div>

          <div className="my-4">
            <input type="hidden" ref={dialogNotesIndexRef} />
            <label htmlFor="dialogNotesText" className="mb-1 block text-gray-500 text-sm">{t('pos.notes')} <span className="text-xs text-gray-500">({t('pos.100_max_characters')})</span></label>
            <input ref={dialogNotesTextRef} type="text" name="dialogNotesText" id='dialogNotesText' className='text-sm w-full rounded-lg px-4 py-2 border border-restro-border-green dark:bg-black focus:outline-restro-border-green' placeholder={t('pos.notes_placeholder')} />
          </div>

          <div className="modal-action">
            <form method="dialog" className='w-full'>
              {/* if there is a button in form, it will close the modal */}
              <button onClick={() => { btnAddNotes(); }} className='rounded-xl transition active:scale-95 hover:shadow-lg w-full px-4 py-3 text-white border border-restro-border-green bg-restro-green hover:bg-restro-green-button-hover'>{t('pos.save')}</button>
            </form>
          </div>
        </div>
      </dialog>
      {/* dialog: notes */}

      {/* dialog: category selection */}
      <dialog id="modal-categories" className="modal modal-bottom sm:modal-middle">
        <div className='modal-box border border-restro-border-green dark:rounded-2xl'>
          <h3 className="font-bold text-lg">{t('pos.filters')}</h3>

          <div className="my-4">
            <label htmlFor="select_category" className='mb-1 text-sm w-full border rounded-lg px-2 py-2 block text-gray-500'>{t('pos.select_category')}</label>
            <select ref={categoryFilterDropdownRef} type="text" name="select_category" id='select_category' className='text-sm w-full rounded-lg px-4 py-2 border border-restro-border-green dark:bg-black focus:outline-restro-border-green' placeholder={t('pos.select_category')} >
              <option value="all">{t('pos.all')}</option>
              {
                categories.filter((category) => category.is_enabled).map((category, index) => <option value={category.id} key={index}>{category.title}</option>)
              }
            </select>
          </div>

          <div className="modal-action">
            <form method="dialog">
              {/* if there is a button in form, it will close the modal */}
              <button onClick={() => { btnClearSelectedCategory() }} className="rounded-lg hover:bg-gray-200 transition active:scale-95 hover:shadow-lg px-4 py-3 bg-gray-200 text-gray-500">{t('pos.close')}</button>
              <button onClick={() => { btnApplyCategoryFilter(); }} className="rounded-lg hover:bg-green-800 transition active:scale-95 hover:shadow-lg px-4 py-3 bg-restro-green text-white ml-3">{t('pos.apply')}</button>
            </form>
          </div>
        </div>
      </dialog>
      {/* dialog: category selection */}

      {/* dialog: variants & addons */}
      <dialog id="modal-variants-addons" className="modal modal-bottom sm:modal-middle">
        <div className='modal-box border border-restro-border-green dark:rounded-2xl'>
          <div className='flex justify-between items-center'>
            <h3 className="font-bold text-lg">{t('pos.select_variant_addons')}</h3>
            <button className='text-red-500 p-2 rounded-full bg-restro-button-hover' onClick={() => document.getElementById('modal-variants-addons').close()}><IconX size={18} stroke={iconStroke} /></button>
          </div>
          <div className="my-8 flex gap-2">
            <div className="flex-1">
              <h3>{t('pos.variants')}</h3>
              <div className="flex flex-col gap-2 mt-2">
                {
                  menuItems.find((item) => item.id == selectedItemId)?.variants?.map((variant, index) => {
                    const { id, item_id, title, price } = variant;

                    const fullItem = state.menuItems.find(item => item.id == selectedItemId);

                    const variantRecipeItems = fullItem.recipeItems?.filter(
                      r => r.variant_id === id && r.addon_id === 0
                    );

                    const isOutOfStock = variantRecipeItems?.length > 0 && variantRecipeItems?.some(
                      (r) => parseFloat(String(String(r.current_quantity || "0").replace(/,/g, "")).replace(/,/g, "")) < parseFloat(String(String(r.recipe_quantity || "1").replace(/,/g, "")).replace(/,/g, ""))
                    );

                    const isLowStock = !isOutOfStock && variantRecipeItems?.some(
                      (r) => parseFloat(String(String(r.current_quantity).replace(/,/g, "")).replace(/,/g, "")) <= parseFloat(String(String(r.min_quantity_threshold).replace(/,/g, "")).replace(/,/g, ""))
                    );

                    const quantitiesPossible = variantRecipeItems?.map(r => {
                      const currentQty = parseFloat(String(String(r.current_quantity || "0").replace(/,/g, "")).replace(/,/g, ""));
                      const requiredQty = parseFloat(String(String(r.recipe_quantity || "1").replace(/,/g, "")).replace(/,/g, ""));
                      return Math.floor(currentQty / requiredQty);
                    });

                    const minItemsCanBeMade = quantitiesPossible?.length > 0
                      ? Math.min(...quantitiesPossible)
                      : null;

                    return (
                      <label key={index} className='cursor-pointer label justify-start gap-2'>
                        <input type="radio" className='radio' name="variants" id="" value={id} defaultChecked={index == 0} />
                        <div>
                          <span className="label-text">{title} - {currency}{price}</span>
                          {isOutOfStock ? (
                            <div className="mt-1 bg-red-100 text-red-700 text-[10px] font-bold px-1.5 py-[2px] z-10 w-full flex items-center justify-center gap-1 rounded-md">
                              <IconAlertTriangleFilled size={12} />
                              <span>{t('inventory.status_out_of_stock') || 'Out of Stock'}</span>
                            </div>
                          ) : isLowStock && (
                            <div className="mt-1 bg-yellow-100 text-yellow-800 text-[10px] font-medium px-1 py-[1px] z-10 w-full flex flex-col items-center gap-[2px] rounded-md">
                              <div className="flex items-center gap-1">
                                <IconAlertTriangleFilled size={12} />
                                <span>{t('inventory.low_stock')} - {minItemsCanBeMade} {t('inventory.qty')}</span>
                              </div>
                            </div>
                          )}
                        </div>
                      </label>
                    )
                  })
                }
              </div>
            </div>
            <div className="flex-1">
              <h3>{t('pos.addons')}</h3>
              <div className="flex flex-col gap-2 mt-2">
                {
                  state.menuItems.find((item) => item.id == selectedItemId)?.addons?.map((addon, index) => {
                    const { id, item_id, title, price } = addon;

                    const fullItem = menuItems.find(item => item.id == selectedItemId);

                    const addonRecipeItems = fullItem.recipeItems?.filter(
                      (r) => r.addon_id === id && r.variant_id === 0
                    );

                    const quantitiesPossible = addonRecipeItems?.map(r => {
                      const currentQty = parseFloat(String(String(r.current_quantity || "0").replace(/,/g, "")).replace(/,/g, ""));
                      const requiredQty = parseFloat(String(String(r.recipe_quantity || "1").replace(/,/g, "")).replace(/,/g, ""));
                      return Math.floor(currentQty / requiredQty);
                    });

                    const minItemsCanBeMade = quantitiesPossible?.length > 0
                      ? Math.min(...quantitiesPossible)
                      : null;

                    const isOutOfStock = addonRecipeItems?.length > 0 && addonRecipeItems?.some(
                      (r) => parseFloat(String(String(r.current_quantity || "0").replace(/,/g, "")).replace(/,/g, "")) < parseFloat(String(String(r.recipe_quantity || "1").replace(/,/g, "")).replace(/,/g, ""))
                    );

                    const isLowStock = !isOutOfStock && addonRecipeItems?.some(
                      (r) => parseFloat(String(String(r.current_quantity).replace(/,/g, "")).replace(/,/g, "")) <= parseFloat(String(String(r.min_quantity_threshold).replace(/,/g, "")).replace(/,/g, ""))
                    );

                    return (
                      <label key={index} className='cursor-pointer label justify-start gap-2'>
                        <input type="checkbox" name="addons" id="" className='checkbox  checkbox-sm' value={id} />
                        <div>
                          <span className="label-text">{title} (+{currency}{price})</span>
                          {isOutOfStock ? (
                            <div className="mt-1 bg-red-100 text-red-700 text-[10px] font-bold px-1.5 py-[2px] z-10 w-full flex items-center justify-center gap-1 rounded-md">
                              <IconAlertTriangleFilled size={12} />
                              <span>{t('inventory.status_out_of_stock') || 'Out of Stock'}</span>
                            </div>
                          ) : isLowStock && (
                            <div className="mt-1 bg-yellow-100 text-yellow-800 text-[10px] font-medium px-1 py-[1px] z-10 w-full flex flex-col items-center gap-[2px] rounded-md">
                              <div className="flex items-center gap-1">
                                <IconAlertTriangleFilled size={12} />
                                <span>{t('inventory.low_stock')} - {minItemsCanBeMade} {t('inventory.qty')}</span>
                              </div>
                            </div>
                          )}
                        </div>
                      </label>
                    )
                  })
                }
              </div>
            </div>
          </div>

          <div className="modal-action">
            <form method="dialog" className="w-full flex gap-2">
              {/* if there is a button in form, it will close the modal */}
              <button onClick={() => { btnAddMenuItemToCartWithVariantsAndAddon() }} className='transition active:scale-95 hover:shadow-lg w-full px-4 py-3 text-white rounded-xl border border-restro-border-green bg-restro-green hover:bg-restro-green-button-hover'>{t('pos.add')}</button>
            </form>
          </div>
        </div>
      </dialog>
      {/* dialog: variants & addons */}


      {/* dialog: save draft */}
      <dialog id="modal-save-draft" className="modal modal-bottom sm:modal-middle">
        <div className='modal-box border border-restro-border-green dark:rounded-2xl'>
          <h3 className="font-bold text-lg">{t('pos.save_cart_items_to_drafts')}</h3>

          <div className="my-4">
            <label htmlFor="draftTitleRef" className="mb-1 block text-gray-500 text-sm">{t('pos.reference')}</label>
            <input ref={draftTitleRef} type="text" name="draftTitleRef" id='draftTitleRef' className='text-sm w-full rounded-lg px-4 py-2 border border-restro-border-green dark:bg-black focus:outline-restro-border-green' placeholder={t('pos.enter_reference_name')} />
          </div>

          <div className="modal-action">
            <form method="dialog">
              {/* if there is a button in form, it will close the modal */}
              <button className='btn transition active:scale-95 hover:shadow-lg px-4 py-3 flex-1 items-center justify-center align-center rounded-xl border border-restro-border-green bg-restro-card-bg hover:bg-restro-button-hover text-restro-text'>{t('pos.close')}</button>
              <button onClick={() => { btnAddtoDrafts(); }} className='rounded-xl transition active:scale-95 hover:shadow-lg px-4 py-3 text-white ml-3 border border-restro-border-green bg-restro-green hover:bg-restro-green-button-hover'>{t('pos.save')}</button>
            </form>
          </div>
        </div>
      </dialog>
      {/* dialog: save draft */}

      {/* dialog: drafts list */}
      <dialog id="modal-drafts" className="modal modal-bottom sm:modal-middle">
        <div className='modal-box p-0 border border-restro-border-green dark:rounded-2xl'>
          <div className='flex justify-between items-center sticky top-0 backdrop-blur px-6 py-4 bg-restro-gray'>
            <h3 className="font-bold text-lg">{t('pos.drafts')}</h3>
            <form method="dialog" className='flex gap-1'>
              {/* if there is a button in form, it will close the modal */}
              <button onClick={btnClearDrafts} className='transition active:scale-95 text-red-500 p-2 rounded-ful rounded-full w-9 h-9 flex items-center justify-center hover:bg-restro-button-hover'><IconClearAll stroke={iconStroke} /></button>
              <button className='transition active:scale-95 text-restro-text p-2 rounded-ful rounded-full w-9 h-9 flex items-center justify-center hover:bg-restro-button-hover'><IconX stroke={iconStroke} /></button>
            </form>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 px-6 pb-6 pt-4">
            {drafts.map((draftItem, index) => {
              const { nameRef, date, cart } = draftItem;

              return <div key={index} className='flex items-center gap-1 rounded-2xl p-2 border border-restro-border-green'>
                <div className='w-12 h-12 rounded-full flex items-center justify-center text-restro-text bg-restro-bg-gray'>
                  <IconClipboardList stroke={iconStroke} />
                </div>
                <div className='flex-1'>
                  <p>{t('pos.ref')}: {nameRef}</p>
                  <p className='text-xs'>{cart?.length} {t('pos.cart_items')}</p>
                  <p className='text-xs text-gray-500'>{date}</p>
                </div>
                <div className="flex flex-col gap-1">
                  <button onClick={() => { btnSelectDraftItemToCart(draftItem) }} className='rounded-full transition active:scale-95 w-6 h-6 flex items-center justify-center text-restro-text bg-restro-gray hover:bg-restro-button-hover'><IconPencil size={14} stroke={iconStroke} /></button>

                  <button onClick={() => { btnDeleteDraftItem(index) }} className='rounded-full transition active:scale-95 text-red-500 w-6 h-6 flex items-center justify-center bg-restro-gray hover:bg-restro-button-hover'><IconTrash size={14} stroke={iconStroke} /></button>
                </div>
              </div>
            })}
          </div>


        </div>
      </dialog>
      {/* dialog: drafts list */}

      <DialogAddCustomer defaultValue={state.addCustomerDefaultValue} onSuccess={(phone, name) => {
        setCustomer({ value: phone, label: `${name} - (${phone})` })
        document.getElementById("modal-search-customer").close();
      }} />

      {/* dialog: search customer */}
      <dialog id="modal-search-customer" className="modal modal-bottom sm:modal-middle">
        <div className='modal-box border border-restro-border-green dark:rounded-2xl h-96'>
          <div className="flex items-center justify-between">

            <h3 className="font-bold text-lg">{t('pos.search_customer')}</h3>
            <form method="dialog">
              <button onClick={btnClearSearchCustomer} className='btn btn-circle btn-sm text-restro-text border-none bg-restro-gray hover:bg-restro-button-hover'><IconRotate size={18} stroke={iconStroke} /></button>
              <button className='ml-2 btn btn-circle btn-sm text-red-500 border-none bg-restro-gray hover:bg-restro-button-hover'><IconX size={18} stroke={iconStroke} /></button>
            </form>
          </div>

          <div className="my-4 flex items-end gap-2">
            <div className='flex-1'>
              <label htmlFor="searchCustomerRef" className="mb-1 block text-gray-500 text-sm">{t('pos.search_customer')}</label>
              {/* <input ref={searchCustomerRef} type="search" name="searchCustomerRef" id='searchCustomerRef' className="text-sm w-full border rounded-lg px-4 py-2 bg-gray-50 outline-restro-border-green-light" placeholder="Enter Customer Phone here..." /> */}
              <AsyncCreatableSelect
                menuPlacement='auto'
                loadOptions={searchCustomersAsync}
                isClearable
                noOptionsMessage={(v) => { return t('pos.type_to_find') }}
                onChange={(v) => {
                  setCustomer(v);
                }}
                onCreateOption={(inputValue) => {
                  setState({
                    ...state,
                    addCustomerDefaultValue: inputValue,
                  })
                  document.getElementById("modal-add-customer").showModal();
                }}
                styles={{
                  control: (base) => ({
                    ...base,
                    backgroundColor: theme === "black" ? "" : "",
                    borderRadius: "0.5rem",
                    borderColor: theme === "black" ? "#232323" : "#f3f4f6",
                    height: 40,
                    boxShadow: "none",
                    color: theme === "black" ? "#ffffff" : "#111827", // text color
                    "&:hover": {
                      borderColor: theme === "black" ? "#23233" : "#9ca3af",
                    },
                  }),
                  menu: (base) => ({
                    ...base,
                    borderRadius: "0.5rem",
                  }),
                  menuList: (base) => ({
                    ...base,
                    maxHeight: 150,
                    overflowY: "auto",
                    borderRadius: "0.5rem",
                    backgroundColor: theme === "black" ? "#232323" : "white",
                  }),
                  option: (base, state) => ({
                    ...base,
                    backgroundColor: state.isFocused
                      ? theme === "black"
                        ? "#292929"
                        : "#e5e7eb"
                      : theme === "black"
                        ? "#232323"
                        : "white",
                    color: theme === "black" ? "#f9fafb" : "#111827",
                    "&:active": {
                      backgroundColor: theme === "black" ? "#6b7280" : "#d1d5db",
                    },
                  }),
                  indicatorSeparator: (base) => ({
                    ...base,
                    backgroundColor: theme === "black" ? "#ffffff" : "#d1d5db", // divider color based on theme
                  }),
                }}
              />
            </div>
          </div>
        </div>
      </dialog>
      {/* dialog: search customer */}

      {/* dialog: send to kitchen summary */}
      <dialog id="modal-send-kitchen-summary" className="modal modal-bottom sm:modal-middle">
        <div className='modal-box border border-restro-border-green dark:rounded-2xl'>
          <div className="flex items-center justify-between gap-4">
            <h3 className="font-bold text-lg">{t('pos.send_order_to_kitchen')}</h3>
            <form method='dialog'>
              <button className='text-red-500 p-2 rounded-full bg-restro-gray hover:bg-restro-button-hover'><IconX size={18} stroke={iconStroke} /></button>
            </form>
          </div>

          <div className="my-8 space-y-4 px-1">
            {[
              { label: t('pos.items_net_total'), value: state.itemsTotal },
              { label: t('pos.tax_total'), value: state.taxTotal, prefix: "+" },
              { label: t('pos.service_charge_total'), value: state.serviceChargeTotal, prefix: "+" },
            ].map(({ label, value, prefix = "" }, index) => (
              <div key={index} className='flex items-center justify-between text-restro-text'>
                <p>{label}</p>
                <p className="text-lg">
                  {prefix}{currency}{value.toFixed(2)}
                </p>
              </div>
            ))}

            <div className="flex items-center justify-between border-t border-gray-300 dark:border-restro-bg-gray pt-2 mt-2">
              <p className="text-xl font-medium">{t('pos.payable_total')}</p>
              <p className="text-xl font-bold text-restro-green">
                {currency}{state.payableTotal.toFixed(2)}
              </p>
            </div>
          </div>


          <div className="modal-action">
            <form method="dialog" className="w-full">
              {/* if there is a button in form, it will close the modal */}
              <button onClick={btnSendToKitchen} className='w-full rounded-xl transition active:scale-95 hover:shadow-lg px-4 py-3 text-white border border-restro-border-green bg-restro-green hover:bg-restro-green-button-hover'>{t('pos.send_to_kitchen')}</button>
            </form>
          </div>
        </div>
      </dialog>
      {/* dialog: send to kitchen summary */}

      {/* dialog: collect payment & send to kitchen summary */}
      <dialog id="modal-pay-and-send-kitchen-summary" className="modal modal-bottom sm:modal-middle">
        <div className='modal-box border border-restro-border-green dark:border-zinc-800 rounded-2xl w-11/12 max-w-3xl bg-gray-50 dark:bg-zinc-950 p-0 overflow-hidden shadow-xl' style={{ contain: 'paint', willChange: 'transform' }}>
          <div className="flex items-center justify-between p-6 bg-white dark:bg-zinc-900 border-b border-gray-100 dark:border-zinc-800">
            <h3 className="font-bold text-xl flex items-center gap-2"><IconReceipt size={24} className="text-restro-green" /> {t('pos.collect_payment_send_order_to_kitchen')}</h3>
            <form method='dialog'>
              <button className='text-gray-500 bg-gray-100 hover:bg-red-100 hover:text-red-500 border-none transition p-2 rounded-full'><IconX size={18} stroke={iconStroke} /></button>
            </form>
          </div>

          <div className="p-6 max-h-[70vh] overflow-y-auto space-y-6 overscroll-contain">

            {/* Summary Section */}
            <div className="bg-gradient-to-r from-gray-50 to-white dark:from-zinc-900 dark:to-zinc-800 rounded-xl border border-gray-200 dark:border-zinc-800 p-5 shadow-sm">
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-1">
                  <div className="text-[10px] uppercase font-bold text-gray-400 tracking-wider">Gross Total</div>
                  <div className="text-xl font-bold">{currency}{state.payableTotal?.toFixed(2)}</div>
                </div>
                <div className="space-y-1 text-right">
                  <div className="text-[10px] uppercase font-bold text-gray-400 tracking-wider">Net Payable</div>
                  <div className="text-2xl font-black text-restro-green">
                    {currency}{(Math.max(0, (state.payableTotal - (state.discountType === "percent" ? (state.payableTotal * state.discount / 100) : state.discount) - (state.loyaltyRedemptionAmount || 0)) + Number(state.roundOff || 0))).toFixed(2)}
                  </div>
                </div>
              </div>

              {/* Detailed Breakdown */}
              <div className="mt-4 pt-4 border-t border-gray-100 dark:border-zinc-700 space-y-2 text-sm">
                <div className="flex justify-between text-gray-500">
                  <span>{t('pos.items_net_total')}</span>
                  <span>{currency}{state.itemsTotal?.toFixed(2)}</span>
                </div>
                <div className="flex justify-between text-gray-500">
                  <span>{t('pos.tax_total')}</span>
                  <span>+{currency}{state.taxTotal?.toFixed(2)}</span>
                </div>
                {state.serviceChargeTotal > 0 && (
                  <div className="flex justify-between text-gray-500">
                    <span>{t('pos.service_charge_total')}</span>
                    <span>+{currency}{state.serviceChargeTotal?.toFixed(2)}</span>
                  </div>
                )}
                {(state.discount > 0 || state.loyaltyRedemptionAmount > 0 || Number(state.roundOff || 0) !== 0) && (
                  <div className="mt-2 space-y-1 bg-white/50 dark:bg-black/20 p-2 rounded-lg border border-emerald-100 dark:border-emerald-900">
                    {(state.discountType === "percent" ? (state.payableTotal * state.discount / 100) : state.discount) > 0 && (
                      <div className="flex justify-between items-center text-emerald-600 text-sm">
                        <span className="font-medium">Direct Discount (छुट):</span>
                        <span className="font-bold">-{currency}{(state.discountType === "percent" ? (state.payableTotal * state.discount / 100) : state.discount).toFixed(2)}</span>
                      </div>
                    )}
                    {state.loyaltyRedemptionAmount > 0 && (
                      <div className="flex justify-between items-center text-amber-600 text-sm">
                        <span className="font-medium">Points Used ({state.loyaltyPointsRedeemed}):</span>
                        <span className="font-bold">-{currency}{state.loyaltyRedemptionAmount.toFixed(2)}</span>
                      </div>
                    )}
                    {Number(state.roundOff || 0) !== 0 && (
                      <div className="flex justify-between items-center text-blue-600 text-sm font-medium">
                        <span>Round Off (राउन्ड अफ):</span>
                        <span className="font-bold">
                          {Number(state.roundOff) > 0 ? `+${currency}${Number(state.roundOff).toFixed(2)}` : `-${currency}${Math.abs(Number(state.roundOff)).toFixed(2)}`}
                        </span>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Discount Section */}
              <div className="bg-white dark:bg-zinc-900 border border-gray-200 dark:border-zinc-800 rounded-xl shadow-sm overflow-hidden flex flex-col">
                <div className="p-4 border-b border-gray-100 dark:border-zinc-800 bg-gray-50/50 dark:bg-zinc-950/50 flex items-center gap-2">
                  <IconDiscount size={18} className="text-emerald-500" />
                  <h4 className="font-semibold text-sm">Additional Discount</h4>
                </div>
                <div className="p-4 space-y-3 flex-1 flex flex-col">
                  <div className="flex justify-between">
                    <label className="text-xs font-bold uppercase tracking-wider text-gray-400">Apply Discount</label>
                    <select
                      value={state.discountType}
                      onChange={(e) => setState({ ...state, discountType: e.target.value, targetTotal: undefined })}
                      className="text-xs font-bold bg-gray-100 dark:bg-zinc-800 rounded px-2 py-1 outline-none"
                    >
                      <option value="fixed">Fixed ({currency})</option>
                      <option value="percent">Percent (%)</option>
                    </select>
                  </div>
                  <div className="relative mt-auto">
                    <input
                      type="number"
                      value={state.discount || ""}
                      onChange={(e) => {
                        const discount = parseFloat(String(String(e.target.value).replace(/,/g, "")).replace(/,/g, "")) || 0;
                        setState({ ...state, discount, targetTotal: undefined });
                      }}
                      placeholder=""
                      className="w-full px-3 py-3 rounded-xl border border-gray-200 dark:border-zinc-800 bg-transparent text-sm focus:ring-1 focus:ring-restro-green focus:outline-none"
                    />
                  </div>
                </div>
              </div>

              {/* Cash Tender Section */}
              <div className="bg-white dark:bg-zinc-900 border border-gray-200 dark:border-zinc-800 rounded-xl shadow-sm overflow-hidden flex flex-col">
                <div className="p-4 border-b border-gray-100 dark:border-zinc-800 bg-gray-50/50 dark:bg-zinc-950/50 flex items-center gap-2">
                  <IconCalculator size={18} className="text-amber-600" />
                  <h4 className="font-semibold text-sm">Cash Tendered</h4>
                </div>
                <div className="p-4 space-y-3 flex-1 flex flex-col justify-between">
                  <div className="relative">
                    <input
                      type="number"
                      value={state.cashTendered || ""}
                      onChange={(e) => {
                        const cashTendered = parseFloat(String(String(e.target.value).replace(/,/g, "")).replace(/,/g, "")) || 0;
                        setState({ ...state, cashTendered });
                      }}
                      placeholder=""
                      className="w-full px-3 py-3 rounded-xl border border-gray-200 dark:border-zinc-800 bg-transparent text-sm focus:ring-1 focus:ring-amber-500 focus:outline-none"
                    />
                  </div>
                  <div className="flex items-center justify-between p-3 bg-gray-50 dark:bg-zinc-950 rounded-lg border border-gray-100 dark:border-zinc-800 mt-2">
                    <span className="text-xs font-bold uppercase tracking-wider text-gray-500">Change Due</span>
                    <span className="font-black text-blue-500 text-lg">
                      {currency}{(Math.max(0, (state.cashTendered || 0) - (state.paidAmount === undefined ? (Math.max(0, (state.payableTotal - (state.discountType === "percent" ? (state.payableTotal * state.discount / 100) : state.discount) - (state.loyaltyRedemptionAmount || 0)) + Number(state.roundOff || 0))) : state.paidAmount))).toFixed(2)}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Round Off Section */}
            <div className="bg-white dark:bg-zinc-900 border border-gray-200 dark:border-zinc-800 rounded-xl shadow-sm overflow-hidden">
               <div className="p-4 border-b border-gray-100 dark:border-zinc-800 bg-gray-50/50 dark:bg-zinc-950/50 flex items-center justify-between">
                 <div className="flex items-center gap-2">
                   <IconScale size={18} className="text-blue-500" />
                   <div>
                     <h4 className="font-semibold text-sm">Round Off (राउन्ड अफ)</h4>
                     <p className="text-[10px] text-gray-400">Separate from discount • Adjusts final bill payable amount</p>
                   </div>
                 </div>
                 {Number(state.roundOff || 0) !== 0 && (
                   <span className={`text-xs font-bold px-2.5 py-1 rounded-full ${Number(state.roundOff) < 0 ? 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300' : 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300'}`}>
                     Round Off: {Number(state.roundOff) > 0 ? `+${currency}${Number(state.roundOff).toFixed(2)}` : `-${currency}${Math.abs(Number(state.roundOff)).toFixed(2)}`}
                   </span>
                 )}
               </div>
               <div className="p-4 space-y-3">
                  <div>
                    <label className="text-[10px] font-bold uppercase tracking-wider text-gray-400 block mb-1.5">Quick Presets</label>
                    <div className="flex flex-wrap gap-2">
                      <button
                        type="button"
                        onClick={() => {
                          const before = Math.max(0, (state.payableTotal || 0) - (state.discountType === "percent" ? ((state.payableTotal || 0) * (state.discount || 0) / 100) : (state.discount || 0)) - (state.loyaltyRedemptionAmount || 0));
                          const target = Math.floor(before / 10) * 10;
                          const diff = parseFloat((target - before).toFixed(2));
                          setState(prev => ({ ...prev, roundOff: diff, targetTotal: undefined, paidAmount: undefined }));
                        }}
                        className="px-3 py-1.5 bg-gray-100 hover:bg-blue-50 hover:text-blue-600 dark:bg-zinc-800 dark:hover:bg-zinc-700 rounded-lg text-xs font-bold transition"
                      >
                        Floor 10 (e.g. 212.5 &rarr; 210)
                      </button>
                      <button
                        type="button"
                        onClick={() => {
                          const before = Math.max(0, (state.payableTotal || 0) - (state.discountType === "percent" ? ((state.payableTotal || 0) * (state.discount || 0) / 100) : (state.discount || 0)) - (state.loyaltyRedemptionAmount || 0));
                          const target = Math.round(before / 10) * 10;
                          const diff = parseFloat((target - before).toFixed(2));
                          setState(prev => ({ ...prev, roundOff: diff, targetTotal: undefined, paidAmount: undefined }));
                        }}
                        className="px-3 py-1.5 bg-gray-100 hover:bg-blue-50 hover:text-blue-600 dark:bg-zinc-800 dark:hover:bg-zinc-700 rounded-lg text-xs font-bold transition"
                      >
                        Nearest 10
                      </button>
                      <button
                        type="button"
                        onClick={() => {
                          const before = Math.max(0, (state.payableTotal || 0) - (state.discountType === "percent" ? ((state.payableTotal || 0) * (state.discount || 0) / 100) : (state.discount || 0)) - (state.loyaltyRedemptionAmount || 0));
                          const target = Math.floor(before / 5) * 5;
                          const diff = parseFloat((target - before).toFixed(2));
                          setState(prev => ({ ...prev, roundOff: diff, targetTotal: undefined, paidAmount: undefined }));
                        }}
                        className="px-3 py-1.5 bg-gray-100 hover:bg-blue-50 hover:text-blue-600 dark:bg-zinc-800 dark:hover:bg-zinc-700 rounded-lg text-xs font-bold transition"
                      >
                        Floor 5
                      </button>
                      <button
                        type="button"
                        onClick={() => {
                          const before = Math.max(0, (state.payableTotal || 0) - (state.discountType === "percent" ? ((state.payableTotal || 0) * (state.discount || 0) / 100) : (state.discount || 0)) - (state.loyaltyRedemptionAmount || 0));
                          const target = Math.round(before);
                          const diff = parseFloat((target - before).toFixed(2));
                          setState(prev => ({ ...prev, roundOff: diff, targetTotal: undefined, paidAmount: undefined }));
                        }}
                        className="px-3 py-1.5 bg-gray-100 hover:bg-blue-50 hover:text-blue-600 dark:bg-zinc-800 dark:hover:bg-zinc-700 rounded-lg text-xs font-bold transition"
                      >
                        Nearest 1
                      </button>
                      <button
                        type="button"
                        onClick={() => {
                          setState(prev => ({ ...prev, roundOff: 0, targetTotal: undefined, paidAmount: undefined }));
                        }}
                        className="px-3 py-1.5 bg-gray-100 hover:bg-red-50 hover:text-red-600 dark:bg-zinc-800 dark:hover:bg-zinc-700 rounded-lg text-xs font-bold transition text-gray-500"
                      >
                        Reset (0)
                      </button>
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-3 pt-1">
                    <div>
                      <label className="text-[10px] font-bold uppercase tracking-wider text-gray-400 block mb-1">Round Off (+/-)</label>
                      <input
                        type="number"
                        step="any"
                        value={state.roundOff !== undefined && state.roundOff !== 0 ? state.roundOff : ""}
                        onChange={(e) => {
                          const val = e.target.value === "" ? 0 : parseFloat(e.target.value) || 0;
                          setState(prev => ({ ...prev, roundOff: val, targetTotal: undefined, paidAmount: undefined }));
                        }}
                        placeholder="0.00"
                        className="w-full px-3 py-2.5 rounded-xl border border-gray-200 dark:border-zinc-800 bg-transparent text-sm font-semibold focus:ring-1 focus:ring-blue-500 focus:outline-none"
                      />
                    </div>
                    <div>
                      <label className="text-[10px] font-bold uppercase tracking-wider text-gray-400 block mb-1">Target Rounded Total</label>
                      <input
                        type="number"
                        step="any"
                        value={
                          state.targetTotal !== undefined
                            ? state.targetTotal
                            : (() => {
                                const before = Math.max(0, (state.payableTotal || 0) - (state.discountType === "percent" ? ((state.payableTotal || 0) * (state.discount || 0) / 100) : (state.discount || 0)) - (state.loyaltyRedemptionAmount || 0));
                                return Number((before + Number(state.roundOff || 0)).toFixed(2));
                              })()
                        }
                        onChange={(e) => {
                          const val = e.target.value;
                          if (val === "") {
                            setState(prev => ({ ...prev, targetTotal: "", roundOff: 0, paidAmount: undefined }));
                            return;
                          }
                          const target = parseFloat(val);
                          if (!isNaN(target)) {
                            const before = Math.max(0, (state.payableTotal || 0) - (state.discountType === "percent" ? ((state.payableTotal || 0) * (state.discount || 0) / 100) : (state.discount || 0)) - (state.loyaltyRedemptionAmount || 0));
                            const diff = parseFloat((target - before).toFixed(2));
                            setState(prev => ({ ...prev, targetTotal: val, roundOff: diff, paidAmount: undefined }));
                          } else {
                            setState(prev => ({ ...prev, targetTotal: val }));
                          }
                        }}
                        onBlur={() => {
                          setState(prev => ({ ...prev, targetTotal: undefined }));
                        }}
                        placeholder="Target Bill"
                        className="w-full px-3 py-2.5 rounded-xl border border-gray-200 dark:border-zinc-800 bg-transparent text-sm font-bold text-restro-green focus:ring-1 focus:ring-restro-green focus:outline-none"
                      />
                    </div>
                  </div>
               </div>
            </div>

            {/* Payments Section */}
            <div className="bg-white dark:bg-zinc-900 border border-gray-200 dark:border-zinc-800 rounded-xl shadow-sm overflow-hidden">
              <div className="p-4 border-b border-gray-100 dark:border-zinc-800 bg-gray-50/50 dark:bg-zinc-950/50 flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <IconCreditCard size={18} className="text-indigo-500" />
                  <h4 className="font-semibold text-sm">Payments</h4>
                </div>
                <button
                  onClick={addPaymentRow}
                  className="text-xs font-bold text-indigo-600 hover:bg-indigo-50 dark:hover:bg-indigo-900/30 px-2 py-1 rounded-lg transition"
                >
                  + Add Split Payment
                </button>
              </div>
              <div className="p-4 space-y-4">
                {state.multiPayments.length > 0 ? (
                  <div className="space-y-3">
                    {state.multiPayments.map((payment, index) => (
                      <div key={index} className="flex gap-3 items-center bg-gray-50 dark:bg-zinc-950 p-3 rounded-xl border border-gray-100 dark:border-zinc-800">
                        <select
                          value={payment.payment_type_id}
                          onChange={(e) => handleMultiPaymentChange(index, 'payment_type_id', e.target.value)}
                          className="flex-1 bg-white dark:bg-zinc-900 border border-gray-200 dark:border-zinc-700 rounded-lg px-3 py-2 text-sm outline-none focus:ring-1 ring-indigo-500"
                        >
                          {(paymentTypes||[]).map(pt => (
                            <option key={pt.id} value={pt.id}>{pt.title}</option>
                          ))}
                        </select>
                        <div className="relative w-32">
                          <input
                            type="number"
                            value={payment.amount}
                            onChange={(e) => handleMultiPaymentChange(index, 'amount', parseFloat(String(String(e.target.value).replace(/,/g, "")).replace(/,/g, "")) || 0)}
                            className="w-full bg-white dark:bg-zinc-900 border border-gray-200 dark:border-zinc-700 rounded-lg pl-6 pr-3 py-2 text-sm font-bold outline-none focus:ring-1 ring-indigo-500"
                          />
                          <span className="absolute left-2 top-1/2 -translate-y-1/2 text-gray-400 text-xs">{currency}</span>
                        </div>
                        <button
                          onClick={() => removePaymentRow(index)}
                          className="btn btn-sm btn-circle btn-ghost text-red-400 hover:text-red-600 hover:bg-red-50"
                        >
                          <IconTrash size={16} />
                        </button>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                    {(paymentTypes||[]).map((paymentType, i) => {
                      const uniqueId = `icon-${paymentType?.id}`;
                      return <label key={i} className='block cursor-pointer'>
                        <input
                          checked={state?.selectedPaymentType == paymentType?.id}
                          onChange={e => {
                            setState({
                              ...state,
                              selectedPaymentType: e.target.value,
                            });
                          }} type="radio" name="payment_type" id={uniqueId} value={paymentType?.id} className='peer hidden' />
                        <div className='border-2 border-transparent dark:bg-zinc-950 bg-gray-50 rounded-xl flex items-center justify-center gap-2 flex-col px-4 py-4 peer-checked:border-restro-green peer-checked:bg-restro-green-light/10 peer-checked:text-restro-green transition shadow-sm'>
                          {paymentType?.icon && <div className={state?.selectedPaymentType == paymentType?.id ? 'text-restro-green' : 'text-gray-400'}>{PAYMENT_ICONS[paymentType?.icon]}</div>}
                          <p className='text-xs font-bold'>{paymentType.title}</p>
                        </div>
                      </label>
                    })}
                  </div>
                )}

                {state.selectedPaymentType && (paymentTypes?.find ? paymentTypes : []).find(pt => pt.id == state.selectedPaymentType)?.qr_config && (
                  <div className="mt-4 flex flex-col items-center justify-center p-6 bg-gray-50 dark:bg-zinc-950 border border-gray-200 dark:border-zinc-800 rounded-xl">
                    <p className="text-sm font-bold text-gray-500 mb-4 uppercase tracking-widest">Scan to Pay</p>
                    <PaymentQRDisplay 
                      paymentType={(paymentTypes?.find ? paymentTypes : []).find(pt => pt.id == state.selectedPaymentType)}
                      amount={state.paidAmount === undefined ? (Math.max(0, (state.payableTotal - (state.discountType === "percent" ? (state.payableTotal * state.discount / 100) : state.discount) - (state.loyaltyRedemptionAmount || 0)) + Number(state.roundOff || 0))) : state.paidAmount}
                      orderId={state.activeOrderId}
                      onSuccess={btnPayAndSendToKitchen}
                    />
                    <p className="mt-4 text-xs text-center text-gray-400">Ask the customer to scan this QR code with their payment app.</p>
                  </div>
                )}

                <div className="mt-4 flex items-center justify-between bg-emerald-50 dark:bg-emerald-900/10 p-4 rounded-xl border border-emerald-100 dark:border-emerald-900">
                  <span className="text-sm font-bold text-emerald-800 dark:text-emerald-300 uppercase tracking-wider">Total Received</span>
                  <div className="flex items-center gap-2">
                    <span className="text-emerald-600 font-medium">{currency}</span>
                    <input
                      type="number"
                      value={state.paidAmount === undefined ? (Math.max(0, (state.payableTotal - (state.discountType === "percent" ? (state.payableTotal * state.discount / 100) : state.discount) - (state.loyaltyRedemptionAmount || 0)) + Number(state.roundOff || 0))) : state.paidAmount}
                      onChange={(e) => {
                        const paidAmount = parseFloat(String(String(e.target.value).replace(/,/g, "")).replace(/,/g, ""));
                        setState({ ...state, paidAmount });
                      }}
                      className="w-28 text-right bg-transparent border-b-2 border-emerald-300 dark:border-emerald-700 text-xl font-black text-emerald-700 dark:text-emerald-400 focus:outline-none focus:border-emerald-500"
                    />
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div className="p-6 bg-gray-50 dark:bg-zinc-900 border-t border-gray-200 dark:border-zinc-800 flex justify-end">
            <button onClick={() => { btnPayAndSendToKitchen(); }} className='w-full md:w-auto rounded-xl transition active:scale-95 shadow-lg px-8 py-4 text-white font-bold bg-restro-green hover:bg-restro-green-button-hover flex justify-center items-center gap-2'>
              <IconCheck size={20} /> {t('pos.collect_payment_send_to_kitchen')}
            </button>
          </div>
        </div>
      </dialog>
      {/* dialog: collect payment & send to kitchen summary */}

      {/* dialog: print-token */}
      <dialog id="modal-print-token" className="modal modal-bottom sm:modal-middle">
        <div className='modal-box border border-restro-border-green dark:rounded-2xl'>
          <h3 className="font-bold text-lg text-center">{t('pos.order_sent_to_kitchen')}</h3>

          <div className="my-8 mx-auto w-fit">
            <div className="flex items-center gap-2">
              <div className="w-12 h-12 flex items-center justify-center bg-restro-green text-white rounded-full">
                <IconCheck stroke={iconStroke} size={32} />
              </div>
              <p className="font-bold text-5xl">#{state?.tokenNo}</p>
            </div>

            <p className="text-sm mt-4 text-center">{t('pos.order_id')}: {state?.orderId}</p>
          </div>

          <div className="modal-action justify-center">
            <form method="dialog">
              {/* if there is a button in form, it will close the modal */}
              <button className='btn transition active:scale-95 hover:shadow-lg px-4 py-3 flex-1 items-center justify-center align-center rounded-xl border border-restro-border-green bg-restro-card-bg hover:bg-restro-button-hover text-restro-text'>{t('pos.close')}</button>
              <button onClick={btnPrintTokenOnly} className='rounded-xl transition active:scale-95 hover:shadow-lg px-4 py-3 text-white ml-3 border border-restro-border-green bg-restro-green hover:bg-restro-green-button-hover'>{t('pos.print_token')}</button>
            </form>
          </div>
        </div>
      </dialog>
      {/* dialog: print-token */}

      {/* dialog: qrorders */}
      <dialog id="modal-qrorders" className="modal modal-bottom sm:modal-middle">
        <div className='modal-box border border-restro-border-green dark:rounded-2xl p-0'>
          <div className="flex justify-between items-center sticky top-0 px-6 py-4">
            <h3 className="font-bold text-lg">{t('pos.qr_orders')}</h3>
            <form method="dialog" className='flex gap-2'>
              {/* if there is a button in form, it will close the modal */}
              <button onClick={btnClearQROrders} className="rounded-full hover:bg-red-200 transition active:scale-95 bg-red-50 dark:bg-red-500 dark:text-white text-red-500 w-9 h-9 flex items-center justify-center"><IconClearAll stroke={iconStroke} /></button>
              <button className="rounded-full hover:bg-gray-200 dark:hover:bg-black transition active:scale-95 bg-gray-100 dark:bg-restro-gray text-gray-500 dark:text-white w-9 h-9 flex items-center justify-center"><IconX stroke={iconStroke} /></button>
            </form>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 px-6 pb-6">
            {state?.qrOrders?.map((qrOrder, index) => {
              const { customer_type, customer_id, customer_name, table_id, table_title, items, id, source } = qrOrder;

              return <div key={index} className='flex items-center gap-1 rounded-2xl p-2 border dark:border-restro-gray'>
                <div className='w-12 h-12 rounded-full bg-gray-100 dark:bg-restro-gray dark:text-white text-gray-500 flex items-center justify-center'>
                  <IconClipboardList stroke={iconStroke} />
                </div>
                <div className='flex-1'>
                  <div className="flex items-center gap-1 text-xs text-gray-500">
                    {source ? <IconBed stroke={iconStroke} size={14} /> : <IconArmchair2 stroke={iconStroke} size={14} />}
                    <p className=''>{source || table_title || "N/A"}</p>
                  </div>
                  <div className="flex items-center gap-1 text-xs">
                    <IconUser stroke={iconStroke} size={14} />
                    <p className=''>{customer_type == "WALKIN" ? "WALKIN" : customer_name}</p>
                  </div>
                  <p className='text-xs'>{items?.length} {t('pos.cart_items')}</p>
                </div>
                <div className="flex flex-col gap-1">
                  <button onClick={() => { btnSelectQROrder(qrOrder) }} className='rounded-full transition active:scale-95 w-6 h-6 flex items-center justify-center text-restro-text bg-restro-gray hover:bg-restro-button-hover'><IconPencil size={14} stroke={iconStroke} /></button>

                  <button onClick={() => { btnCancelQROrder(id) }} className='rounded-full transition active:scale-95 text-red-500 w-6 h-6 flex items-center justify-center bg-restro-gray hover:bg-restro-button-hover'><IconTrash size={14} stroke={iconStroke} /></button>
                </div>
              </div>
            })}
          </div>
        </div>
      </dialog>
      {/* dialog: qrorders */}
    </Page>
  )
}
